<template>
  <div>
    <div class="newFash">
      <div class="nf_top_tilte dis al_c ju_s">
        <div class="font14_335">
          回收业务配置<span style="color: #26BE3D;" v-if="source == 'online'">（已启用线上支付）</span>
        </div>
        <div class="font12_77">
          <span>最近修改时间: {{ updateTime||"--" }}</span>
        </div>
      </div>
      <div class="nf_second_tabl">
        <div class="nf_f_content dis al_c">
          <div
            :class="{ nf_ta_slect: titleIndexsel == item.id, nosleststy: true }"
            v-for="(item, index) in titleDataList"
            :key="index"
            @click="actionTitleId(item.id)"
          >
          <span>{{ item.name }}</span>
          <div v-if="titleIndexsel == item.id" class="blueLineUNder"></div>
          </div>
        </div>
      </div>
      <div  ref="scrollContainer" @scroll="handleContainerScroll" style="width:calc(100vw - 240px); height: calc(100vh - 240px);margin-top: 108px;overflow: auto;">
        <!-- 公司利润设置 -->
        <div class="Companprofiset"  id="first_li" >
          <div class="cp_toptitle">
            <span>公司利润设置</span>
          </div>
          <div class="gray_style">
            <p>
              利润模式：<span class="blod33">{{
                profitMode == "diff" ? "差价模式" : "后返利模式"
              }}</span>
            </p>
            <p>
              返利计算模式：<span class="blod33">{{
                rebateRateMethod == "01"
                  ? "报价金额/(1+返利比例)*返利比例"
                  : "报价金额*返利比例"
              }}</span>
            </p>
            <p>
              结算模式：<span class="blod33">{{
                addPriceSettleStyle == "01"
                  ? "线上结算"
                  : addPriceSettleStyle == "02"
                  ? "线下结算（返利收货退回）"
                  : "线下结算（返利挂账）"
              }}</span>
            </p>
          </div>
          <div class="fanli_cont">
            <p>返利比例&审核</p>
            <div class="di_blue"></div>
          </div>
          <div class="tab_slide" v-if="source == 'online'">
            <div
              :class="{
                public_cation: true,
                select_cation: rebateActiveName == item.templateName,
              }"
              v-for="(item, index) in rebateTemplateList"
              :key="index"
              @click="handleClick(item.templateName, 'rebateActiveName')"
            >
              {{ item.templateName }}
            </div>
          </div>
          <div class="secondlevel">
            <div class="left_line"></div>
            <p>通用机型返利配置</p>
          </div>
          <div
            class="faultBtn"
            :style="
              rebateActiveName != '公共配置（默认）'
                ? 'width: 306px'
                : 'width: 204px'
            "
          >
            <div
              :class="rebateTypeTab === '01' ? 'active' : 'none'"
              @click="rebateBtnClick('01')"
            >
              比例设置
            </div>
            <div
              :class="rebateTypeTab === '02' ? 'active' : 'none'"
              @click="rebateBtnClick('02')"
            >
              申请/审核设置
            </div>
            <div
              v-if="rebateActiveName != '公共配置（默认）'"
              :class="rebateTypeTab === '05' ? 'active' : 'none'"
              @click="rebateBtnClick('05')"
            >
              关联门店
            </div>
          </div>
          <GlobalTable
            v-if="rebateTypeTab == '01'"
            ref="GlobalTable"
            v-loading="rebateloading"
            :columns="rebateColumns"
            :data="
              rebateRegionList.slice(
                (rebatePage.pageNum - 1) * rebatePage.pageSize,
                rebatePage.pageNum * rebatePage.pageSize
              )
            "
            :currentPage="rebatePage.pageNum"
            :total="rebatePage.total"
            :pageSize="rebatePage.pageSize"
            @handleCurrentChange="rebateHandleCurrentChange"
          >
            <el-table-column label="报价区间" slot="rank" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
              </template>
            </el-table-column>
            <el-table-column label="门店返利" slot="rebate" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.rebate }}%</span>
              </template>
            </el-table-column>
            <el-table-column
              label="门店返利上限"
              slot="rebateLimit"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>￥{{ row.rebateLimit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="预留返利" slot="delayRebate" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.delayRebate }}%</span>
              </template>
            </el-table-column>
            <el-table-column
              label="预留返利上限"
              slot="delayRebateLimit"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>￥{{ row.delayRebateLimit }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="差价利润弹性比例"
              slot="cutPriceScope"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{ row.cutPriceScope }}%</span>
              </template>
            </el-table-column>
            <el-table-column
              label="差价利润弹性上限"
              slot="cutPriceScopeLimit"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>￥{{ row.cutPriceScopeLimit }}</span>
              </template>
            </el-table-column>
          </GlobalTable>
          <div v-if="rebateTypeTab == '02'" style="margin-bottom: 20px;">
            <div class="gray_style">
              <p>
                门店返利：<span class="blod33"
                  >{{ isRebateStore == "01" ? "可申请" : "不可申请" }}、{{
                    isRebateStoreAudit == "01" ? "需审核" : "无需审核"
                  }}、{{
                    unUedAddToStaff == "01"
                      ? "未使用加价有提成"
                      : "未使用加价没有提成："
                  }}
                </span>
              </p>
              <p>
                预留返利：<span class="blod33"
                  >{{ isPreRebateStore == "01" ? "可申请" : "不可申请" }}、{{
                    isPreRebateStoreAudit == "01" ? "需审核" : "无需审核"
                  }}</span
                >
              </p>
              <p>
                门店申请加价使用加价：<span class="blod33">{{
                  addPriceUseType == "01"
                    ? "按可申请比例直接选择"
                    : "按可申请比例输入范围内金额"
                }}</span>
              </p>
            </div>
          </div>
          <template
            v-if="
              rebateTypeTab == '05' && rebateActiveName != '公共配置（默认）'
            "
          >
            <div style="margin: -5px 0 12px 0;font-size: 14px;">
              <span
                >共<span style="color:#FF687B;">{{ storeNum }}</span
                >家门店，已关联<span style="color:#FF687B;">{{
                  rebateStoreList.length
                }}</span
                >家</span
              >
            </div>
            <GlobalTable
              class="mb-10"
              ref="multipleTable"
              myKey="rebateStore"
              :isPagination="false"
              :columns="angPowStoreColumns"
              :data="rebateStoreList"
              judgeValue="storeId"
              @handleSelect="(e) => storeHandleSelect(e, 'rebate')"
            >
              <el-table-column
                label="区域/总监"
                width="200"
                slot="areaName"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span v-if="row.areaName && row.inspectorName"
                    >{{ row.areaName }}-{{ row.inspectorName }}</span
                  >
                  <span v-if="row.areaName && !row.inspectorName">{{
                    row.areaName
                  }}</span>
                  <span v-if="!row.areaName && row.inspectorName">{{
                    row.inspectorName
                  }}</span>
                  <span v-if="!row.areaName && !row.inspectorName">--</span>
                </template>
              </el-table-column>
              <el-table-column
                label="门店名称"
                width="200"
                slot="storeName"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.storeName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店长"
                width="200"
                slot="storeManager"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span v-if="row.storeManager"
                    >{{ row.storeManager }}-{{ row.storeManagerPhone }}</span
                  >
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column label="门店标签" slot="tagList" align="center">
                <template slot-scope="{ row }">
                  <div
                    class="tag-list"
                    v-if="row.tagList && row.tagList.length"
                  >
                    <span
                      class="tag-style"
                      v-for="item in row.tagList"
                      :key="item.id"
                      >{{ item.tagName }}</span
                    >
                  </div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </GlobalTable>
          </template>
          <MachineTemplateList
            v-for="(item, index) in machineTemplateList"
            :key="index"
            v-bind="item"
            :machineTemplateList="machineTemplateList"
            :index="index"
            class="mb-20"
            @change="(d) => machineTemplateListChange(index, d)"
            @del="machineTemplateDel(index)"
          />
        </div>
        <!-- 员工红包设置-->
        <div class="Companprofiset" style="border-radius: 16px;height: 500px;" id="second_li" >
          <div class="cp_toptitle">
            <span>员工红包设置</span>
            <div class="gree_on" v-if="isAngPow">已启用红包</div>
            <div class="gree_on red_dwon" v-else>未启用红包</div>
          </div>
          <div v-if="isAngPow">
            <div
              class="tab_slide"
              style="margin-top: 20px;"
              v-if="source == 'online'"
            >
              <div
                :class="{
                  public_cation: true,
                  select_cation: angPowActiveName == item.templateName,
                }"
                v-for="(item, index) in angPowTemplateList"
                :key="index"
                @click="handleClick(item.templateName, 'angPowActiveName')"
              >
                {{ item.templateName }}
              </div>
            </div>
            <div class="button_top">
              <div class="flex">
                <div
                  class="faultBtn"
                  :style="
                    angPowActiveName != '公共配置（默认）'
                      ? 'width: 306px'
                      : 'width: 204px'
                  "
                >
                  <div
                    :class="angPowTypeTab === '01' ? 'active' : 'none'"
                    @click="angPowBtnClick('01')"
                  >
                    金额设置
                  </div>
                  <div
                    :class="angPowTypeTab === '03' ? 'active' : 'none'"
                    @click="angPowBtnClick('03')"
                  >
                    加价设置
                  </div>
                  <div
                    v-if="angPowActiveName != '公共配置（默认）'"
                    :class="angPowTypeTab === '02' ? 'active' : 'none'"
                    @click="angPowBtnClick('02')"
                  >
                    关联门店
                  </div>
                </div>
              </div>
            </div>
            <template v-if="angPowTypeTab == '01'">
              <GlobalTable
                ref="GlobalTable"
                myKey="redPacket"
                v-loading="redPacketloading"
                :columns="redPacketColumns"
                :data="
                  apRegionList.slice(
                    (redPacketPage.pageNum - 1) * redPacketPage.pageSize,
                    redPacketPage.pageNum * redPacketPage.pageSize
                  )
                "
                :currentPage="redPacketPage.pageNum"
                :total="redPacketPage.total"
                :pageSize="redPacketPage.pageSize"
                @handleCurrentChange="redHandleCurrentChange"
              >
                <el-table-column label="报价区间" slot="rank" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="店长红包"
                  slot="shopownerReward"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span
                      >{{ rebateType == "02" ? "￥" : ""
                      }}{{ row.shopownerReward
                      }}{{ rebateType == "01" ? "%" : "" }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="店长红包上限"
                  slot="shopownerRewardLimit"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>￥{{ row.shopownerRewardLimit||'--' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="店员红包"
                  slot="clerkReward"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span
                      >{{ rebateType == "02" ? "￥" : "" }}{{ row.clerkReward
                      }}{{ rebateType == "01" ? "%" : "" }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="店员红包上限"
                  slot="clerkRewardLimit"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>￥{{ row.clerkRewardLimit||'--' }}</span>
                  </template>
                </el-table-column>
              </GlobalTable>
            </template>
            <template
              v-if="
                angPowTypeTab == '02' && angPowActiveName != '公共配置（默认）'
              "
            >
              <div style="margin: -5px 0 12px 0;font-size: 14px;">
                <span
                  >共<span style="color:#FF687B;">{{ storeNum }}</span
                  >家门店，已关联<span style="color:#FF687B;">{{
                    angPowStoreList.length
                  }}</span
                  >家</span
                >
              </div>
              <GlobalTable
                ref="multipleTable"
                myKey="angPowStore"
                :isPagination="false"
                :columns="angPowStoreColumns"
                :data="angPowStoreList"
                judgeValue="storeId"
                @handleSelect="(e) => storeHandleSelect(e, 'red')"
              >
                <el-table-column
                  label="区域/总监"
                  width="200"
                  slot="areaName"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.areaName && row.inspectorName"
                      >{{ row.areaName }}-{{ row.inspectorName }}</span
                    >
                    <span v-if="row.areaName && !row.inspectorName">{{
                      row.areaName
                    }}</span>
                    <span v-if="!row.areaName && row.inspectorName">{{
                      row.inspectorName
                    }}</span>
                    <span v-if="!row.areaName && !row.inspectorName">--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="门店名称"
                  width="200"
                  slot="storeName"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.storeName }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="店长"
                  width="200"
                  slot="storeManager"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.storeManager"
                      >{{ row.storeManager }}-{{ row.storeManagerPhone }}</span
                    >
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="门店标签" slot="tagList" align="center">
                  <template slot-scope="{ row }">
                    <div
                      class="tag-list"
                      v-if="row.tagList && row.tagList.length"
                    >
                      <span
                        class="tag-style"
                        v-for="item in row.tagList"
                        :key="item.id"
                        >{{ item.tagName }}</span
                      >
                    </div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
              </GlobalTable>
            </template>
            <template v-if="angPowTypeTab == '03'">
              <div class="gray_style" style="margin: 0;">
                <p>
                  员工红包是否可用于加价：<span class="blod33">{{
                    isAngPowAddPrice == "01" ? "可加价" : "不可加价"
                  }}</span>
                </p>
              </div>
            </template>
          </div>
          <div class="emp_content" v-else>
            <img src="../image//queshen.png" alt="" />
            <p>您暂未启用该功能</p>
          </div>
        </div>
        <!-- 管理人员提成设置 -->
        <div class="Companprofiset" style="border-radius: 16px;height: 500px;" id="third_li" >
          <div class="cp_toptitle">
            <span>管理人员提成设置</span>
            <div class="gree_on" v-if="isManagerReward">已启用管理人员提成</div>
            <div class="gree_on red_dwon" v-else>未启用管理人员提成</div>
          </div>
          <div v-if="isManagerReward">
             <div
              class="tab_slide"
              style="margin-top: 20px;"
              v-if="source == 'online'"
            >
              <div
                :class="{
                  public_cation: true,
                  select_cation: managerActiveName == item.templateName,
                }"
                v-for="(item, index) in managerTemplateList"
                :key="index"
                @click="handleClick(item.templateName, 'managerActiveName')"
              >
                {{ item.templateName }}
              </div>
            </div>
            <div class="button_top">
              <div class="flex">
                <div class="faultBtn"  :style="
                    managerActiveName != '公共配置（默认）'
                      ? 'width: 360px'
                      : 'width: 240px'
                  ">
                  <div
                    :class="ManagementTypeTab === '01' ? 'active' : 'none'"
                    @click="ManageBtnClick('01')"
                  >
                    发放提成人员
                  </div>
                  <div
                    :class="ManagementTypeTab === '02' ? 'active' : 'none'"
                    @click="ManageBtnClick('02')"
                  >
                    提成规则
                  </div>
                  <div
                    v-if="managerActiveName != '公共配置（默认）'"
                    :class="ManagementTypeTab === '03' ? 'active' : 'none'"
                    @click="ManageBtnClick('03')"
                  >
                    使用门店
                  </div>
                </div>
              </div>
            </div>
            <div class="polpleSetstyle" v-if="ManagementTypeTab === '01'">
              <GlobalTable
                ref="GlobalTable"
                v-loading="refundAuditListloading"
                :columns="CommissionColumns"
                :data="Commissionofficer"
                :isPagination="false"
              >
                <el-table-column label="角色" slot="staffType" align="center">
                  <template slot-scope="{ row }">
                    <span>{{
                      row.isMajor
                        ? "创建人"
                        : row.staffType == "01"
                        ? "子账号"
                        : row.staffType == "02"
                        ? "总监"
                        : row.staffType == "03"
                        ? "店长"
                        : "店员"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="联系电话"
                  slot="staffMobile"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.staffMobile || row.mobile }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="分成比例" slot="possessRate" align="center" width="160">
                <template slot-scope="{ row }">
                  <div class="flex percent-input-wrap" style="justify-content: center">
                     <span>{{ row.possessRate }}%</span>
                  </div>
                </template>
              </el-table-column>
              </GlobalTable>
            </div>
            <div class="polpleSetstyle" v-if="ManagementTypeTab === '02'">
              <el-table border :data="RoyaltyRegionList" class="mb-20">
                <el-table-column
                  label="序号"
                  type="index"
                  width="50"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="rank" label="报价区间" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建人子账号提成"
                  prop="founderReward"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.rebateType == '02'"
                      >￥{{ row.founderReward }}</span
                    >
                    <span v-else>{{ row.founderReward }}%</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建人子账号提成上限"
                  prop="founderRewardLimit"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>￥{{ row.founderRewardLimit }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="总监提成"
                  prop="inspectorReward"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.rebateType == '02'"
                      >￥{{ row.inspectorReward }}</span
                    >
                    <span v-else>{{ row.inspectorReward }}%</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="总监提成上限"
                  prop="inspectorRewardLimit"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>￥{{ row.inspectorRewardLimit }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="polpleSetstyle" v-if="ManagementTypeTab === '03'">
            <div style="margin: -5px 0 12px 0;font-size: 14px;">
              <span 
                    >共<span style="color:#FF687B;">{{ storeNum }}</span
                    >家门店，已关联<span style="color:#FF687B;">{{
                      manageStoreList.length
                    }}</span
                    >家</span
                  >
              </div>
              <GlobalTable
                ref="multipleTable"
                myKey="angPowStore"
                :isPagination="false"
                :columns="angPowStoreColumns"
                :data="manageStoreList"
                judgeValue="storeId"
                @handleSelect="(e) => storeHandleSelect(e, 'red')"
              >
                <el-table-column
                  label="区域/总监"
                  width="200"
                  slot="areaName"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.areaName && row.inspectorName"
                      >{{ row.areaName }}-{{ row.inspectorName }}</span
                    >
                    <span v-if="row.areaName && !row.inspectorName">{{
                      row.areaName
                    }}</span>
                    <span v-if="!row.areaName && row.inspectorName">{{
                      row.inspectorName
                    }}</span>
                    <span v-if="!row.areaName && !row.inspectorName">--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="门店名称"
                  width="200"
                  slot="storeName"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.storeName }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="店长"
                  width="200"
                  slot="storeManager"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.storeManager"
                      >{{ row.storeManager }}-{{ row.storeManagerPhone }}</span
                    >
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="门店标签" slot="tagList" align="center">
                  <template slot-scope="{ row }">
                    <div
                      class="tag-list"
                      v-if="row.tagList && row.tagList.length"
                    >
                      <span
                        class="tag-style"
                        v-for="item in row.tagList"
                        :key="item.id"
                        >{{ item.tagName }}</span
                      >
                    </div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
              </GlobalTable>
            </div>
          </div>
          <div class="emp_content" v-else>
            <img src="../image//queshen.png" alt="" />
            <p>您暂未启用该功能</p>
          </div>
        </div>
        <!-- 压价提成设置-->
        <div class="Companprofiset" style="border-radius: 16px;height: 500px;" id="four_li">
          <div class="cp_toptitle">
            <span>压价提成设置</span>
            <div class="gree_on" v-if="isDepreciateShare">已启用差价提成</div>
            <div class="gree_on red_dwon" v-else>未启用差价提成</div>
          </div>
          <div v-if="isDepreciateShare">
            <div
              class="tab_slide"
              style="margin-top: 20px;"
              v-if="source == 'online'"
            >
              <div
                :class="{
                  public_cation: true,
                  select_cation: DepreciateName == item.templateName,
                }"
                v-for="(item, index) in cutPriceTemplateList"
                :key="index"
                @click="handleClick(item.templateName, 'DepreciateName')"
              >
                {{ item.templateName }}
              </div>
            </div>
            <div class="button_top">
              <div class="flex">
                <div
                  class="faultBtn"
                  :style="
                    DepreciateName != '公共配置（默认）'
                      ? 'width: 208px'
                      : 'width: 104px'
                  "
                >
                  <div
                    style="width: 102px;"
                    :class="DepreciateTypeTab === '01' ? 'active' : 'none'"
                    @click="DepreciateBtnClick('01')"
                  >
                    规则设置
                  </div>
                  <div
                    style="width: 102px;"
                    v-if="DepreciateName != '公共配置（默认）'"
                    :class="DepreciateTypeTab === '02' ? 'active' : 'none'"
                    @click="DepreciateBtnClick('02')"
                  >
                    使用门店
                  </div>
                </div>
              </div>
            </div>
            <div class="secondlevel" style="margin-top: 0;" v-if="
                (afterDepreciateStyle == '01' || profitMode == 'diff') &&
                  source == 'online' &&
                  isDepreciateShare &&
                  DepreciateTypeTab === '01'
              ">
            <div class="left_line"></div>
            <p>常规压价提成<span style="color: #777777;">（成交即可获得常规压价提成）</span></p>
          </div>
            <el-table
              v-if="
                (afterDepreciateStyle == '01' || profitMode == 'diff') &&
                  source == 'online' &&
                  isDepreciateShare &&
                  DepreciateTypeTab === '01'
              "
              :key="tableKey"
              :data="cutPriceRegionList"
              border
              class="mb-20 mt-20"
            >
              <el-table-column label="序号" type="index" width="50">
              </el-table-column>
              <el-table-column
                prop="rank"
                align="center"
                :render-header="addCulateRule"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店长"
                prop="shopownerCutPrice"
                align="center"
              >
                <template slot-scope="{ row }">
                  比例<span>{{ row.shopownerCutPrice }}%</span>
                  上限<span>￥{{ row.shopownerCutPriceLimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店员"
                prop="shopownerCutPriceLimit"
                align="center"
              >
                <template slot-scope="{ row }">
                  比例<span>{{ row.clerkCutPrice }}%</span>
                  上限<span>￥{{ row.clerkCutPriceLimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="总监"
                prop="clerkCutPrice"
                align="center"
              >
                <template slot-scope="{ row }">
                 比例 <span>{{ row.inspectorReward }}%</span>，
                 上限<span>￥{{ row.inspectorRewardLimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="clerkCutPriceLimit"
                align="center"
              >
                <template #header>
                  <span class="designated-setting-header" @click="openBargainDesignatedDialog()">指定<span style="color: #0981FF;" v-if="assignFounderList.length">{{ assignFounderList.length}}</span>人员</span>
                </template>
                <template slot-scope="{ row }">
                 比例 <span>{{ row.founderReward }}%</span>，
                 上限<span>￥{{ row.founderRewardLimit }}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div class="secondlevel"  v-if="
                (afterDepreciateStyle == '01' || profitMode == 'diff') &&
                  source == 'online' &&
                  isDepreciateShare &&
                  DepreciateTypeTab === '01'&&isOpenExtraDepreciateShare
              ">
            <div class="left_line"></div>
            <p>外部压价提成<span style="color: #777777;">（若最高价为外部商家，成交后可获得额外提成）</span></p>
          </div>
            <el-table
              border
              v-if="
                (afterDepreciateStyle == '01' || profitMode == 'diff') &&
                  source == 'online' &&
                  isDepreciateShare &&
                  isOpenExtraDepreciateShare &&
                  DepreciateTypeTab === '01'
              "
              :data="extraCutPriceRegionList"
              class="mb-20 mt-20"
            >
              <el-table-column label="序号" type="index" width="50">
              </el-table-column>
              <el-table-column
                prop="rank"
                align="center"
                :render-header="addCulateRule1"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.lower }}≤区间＜{{ row.upper }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店长差价提成"
                prop="shopownerCutPrice"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.shopownerCutPrice }}%</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店长差价提成上限"
                prop="shopownerCutPriceLimit"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span>￥{{ row.shopownerCutPriceLimit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店员差价提成"
                prop="clerkCutPrice"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.clerkCutPrice }}%</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店员差价提成上限"
                prop="clerkCutPriceLimit"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span>￥{{ row.clerkCutPriceLimit }}</span>
                </template>
              </el-table-column>
            </el-table> -->
            <template
              v-if="
                DepreciateTypeTab == '02' &&
                  DepreciateName != '公共配置（默认）' &&
                  isDepreciateShare
              "
            >
            <div style="margin: -5px 0 12px 0;font-size: 14px;">
              <span 
                    >共<span style="color:#FF687B;">{{ storeNum }}</span
                    >家门店，已关联<span style="color:#FF687B;">{{
                      DepreciateStoreList.length
                    }}</span
                    >家</span
                  >
              </div>
              <GlobalTable
                ref="multipleTable"
                myKey="angPowStore"
                :isPagination="false"
                :columns="angPowStoreColumns"
                :data="DepreciateStoreList"
                judgeValue="storeId"
                @handleSelect="(e) => storeHandleSelect(e, 'red')"
              >
                <el-table-column
                  label="区域/总监"
                  width="200"
                  slot="areaName"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.areaName && row.inspectorName"
                      >{{ row.areaName }}-{{ row.inspectorName }}</span
                    >
                    <span v-if="row.areaName && !row.inspectorName">{{
                      row.areaName
                    }}</span>
                    <span v-if="!row.areaName && row.inspectorName">{{
                      row.inspectorName
                    }}</span>
                    <span v-if="!row.areaName && !row.inspectorName">--</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="门店名称"
                  width="200"
                  slot="storeName"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.storeName }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="店长"
                  width="200"
                  slot="storeManager"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <span v-if="row.storeManager"
                      >{{ row.storeManager }}-{{ row.storeManagerPhone }}</span
                    >
                    <span v-else>--</span>
                  </template>
                </el-table-column>
                <el-table-column label="门店标签" slot="tagList" align="center">
                  <template slot-scope="{ row }">
                    <div
                      class="tag-list"
                      v-if="row.tagList && row.tagList.length"
                    >
                      <span
                        class="tag-style"
                        v-for="item in row.tagList"
                        :key="item.id"
                        >{{ item.tagName }}</span
                      >
                    </div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
              </GlobalTable>
            </template>
          </div>
          <div class="emp_content" v-else>
            <img src="../image//queshen.png" alt="" />
            <p>您暂未启用该功能</p>
          </div>
        </div>
        <!-- 收款退款设置-->
        <div class="Companprofiset" style="border-radius: 16px;height: 300px;" id="five_li" >
          <div class="cp_toptitle">
            <span>收款退款设置</span>
          </div>
          <div class="gray_style" style="margin-bottom: 20px;">
            <p>
              是否可付款给用户：<span class="blod33">{{
                userPayeeMode == "01" ? "可付款给用户" : "不可付款给用户"
              }}</span>
            </p>
            <p v-if="userPayeeMode=='01'">
              以旧换新是否可付款：<span class="blod33">{{
                userPayeeModeTrade == "01" ? "是" : "否"
              }}</span>
            </p>
            <p v-if="userPayeeMode=='01'">
              店员付款是否需要审核：<span class="blod33">{{
                isStaffPayUserAudit == "01" ? "需审核" : "无需审核"
              }}</span>
            </p>
            <p v-if="userPayeeMode=='02'">
              审核人角色：<span class="blod33">{{
                refundAuditRole == "03"
                  ? "本店店长审核"
                  : "本店所属总监审核"
              }}</span>
            </p>
          </div>
           <div style="margin-bottom: 10px;" v-if="userPayeeMode=='02'">
            <GlobalTable ref="GlobalTable" v-loading="refundAuditListloading" :columns="storePreRebateAuditColumns"
            :data="refundAuditList" :isPagination="false">
            <el-table-column label="角色" slot="staffType" align="center">
              <template slot-scope="{ row }">
                <span>{{
                  row.isMajor
                  ? "创建人"
                  : row.staffType == "01"
                    ? "子账号"
                    : row.staffType == "02"
                      ? "总监"
                      : row.staffType == "03"
                        ? "店长"
                        : "店员"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否关注公众号" slot="isSubscribe" align="center">
              <template slot-scope="{ row }">
                {{ row.isSubscribe ? "是" : "否" }}
              </template>
            </el-table-column>
          </GlobalTable>
           </div>
        </div>
         <!-- 提现设置-->
         <div class="Companprofiset" style="border-radius: 16px;" id="six_li" >
          <div class="cp_toptitle">
            <span>提现设置</span>
          </div>
          <div class="fanli_cont" style="padding: 15px 0 0 0;">
            <p>公司账户提现设置</p>
            <div class="di_blue"></div>
          </div>
          <div class="gray_style" style="margin:15px 0;">
            <p>
              账户余额是否可提现：<span class="blod33">{{
                accountWithdraw == "01" ? "可提现" : "不可提现"
              }}</span>
            </p>
            <p v-if="accountWithdraw=='01'">
              提现到账方式：<span class="blod33">{{
                arrivalMethod == "01" ? "微信零钱包" :  arrivalMethod == "02" ? "银行卡（门店承担千分之一手续费）" : "支付宝"
              }}</span>
            </p>
          </div>
           <div style="margin-bottom: 10px;" v-if="accountWithdraw =='01'">
            <div style="font-size: 14px;font-weight: bold;color: #333333;margin-bottom: 16px;">绑定提现人员</div>
            <GlobalTable ref="GlobalTable" v-loading="withdrawalloading" :columns="withdrawalColumns"
            :data="withdrawalDataList" :isPagination="false">
            <el-table-column label="是否关注公众号" slot="isSubscribe" align="center">
              <template slot-scope="{ row }">
                {{ row.isSubscribe ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column label="微信头像" slot="headImg" align="center">
              <template slot-scope="{ row }">
                <img :src="row.headImg" style="width: 70px;height:70px" alt="" />
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" slot="operation" align="center">
              <template slot-scope="{ row, $index }">
                <el-button size="mini" type="danger" round
                  @click="handleBtn(row, 'del', 'withdrawal', $index)" v-if="!isHistory">移除</el-button>
              </template>
            </el-table-column> -->
          </GlobalTable>
           </div>
           <div class="fanli_cont" style="padding: 15px 0 0 0;">
            <p>员工账户设置</p>
            <div class="di_blue"></div>
          </div>
          <div class="gray_style" style="margin:15px 0;">
            <p>
              到账配置：<span class="blod33">{{
                apIntoMode == "per" ? "到账员工个人账户" : "统一到账公司账户"
              }}</span>
            </p>
            <p v-if="apIntoMode == 'per'">
              提现到账方式：<span class="blod33">{{
                rewardWithdrawChannel == "01" ?  "提现到微信" : "提现到支付宝"
              }}</span>
            </p>
            <p v-if="apIntoMode == 'per'">
              是否需要审核：<span class="blod33">{{
                isStaffWithdrawalAudit == "01" ?  "需审核" : "无需审核"
              }}</span>
            </p>
            <p v-if="apIntoMode == 'per'">
              到账时机：<span class="blod33">{{
                rewardLateArrivalType == "01" ?  "确认交易即到账" : rewardLateArrivalType == "02" ?  "上传成交凭证到账" : "完成发货到账"
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
     <!-- 常规压价 -->
     <el-dialog :title="calculateTitle" :visible.sync="calculateNormalShow" :close-on-click-modal="false" width="850px">
      <div v-if="typeCalculate == 'normal'">
        <span>门店显示价为报价扣除返利红包的金额</span>
        <div class="normalShow mb-20 mt-20" style="background-color: #e4ecfd;">
          <div class="flex flex-jb">
            <span style="font-weight: 700;color: black;">与平台回收商成交时：</span> <span
              style="font-weight: 700;color: #0981ff;">常规压价金额=成交回收商报价门店显示价-顾客实际成交价 (不含换新补贴)</span>
          </div>
          <div style="font-size:12px;color:#666">例如: 回收商(非外部)门店成交价1200，顾客成交价800，则常规压价=1200-200=400元</div>
        </div>
        <div class="normalShow mb-20">
          <div class="flex flex-jb">
            <span style="font-weight: 700;color: black;">与外部回收商成交，未开通外部压价提成时：</span> <span
              style="font-weight: 700;color: #f76654;">常规压价金额=外部成交回收商报价的门店显示价-顾客实际成交价 (不含换新补贴)</span>
          </div>
          <div style="font-size:12px;color:#666">例如:外部回收商最高门店成交价1200，平台回收商最高门店成交价1000，顾客成交价800，则常规压价=1200-800=400元</div>
        </div>
        <div class="normalShow mb-20">
          <div class="flex flex-jb">
            <span style="font-weight: 700;color: black;">与外部回收商成交时，已开通外部压价提成时：</span> <span
              style="font-weight: 700;color: #f76654;">常规压价金额=平台最高回收商报价的门店显示价-顾客实际成交价(不含换新补贴)</span>
          </div>
          <div style="font-size:12px;color:#666">例如:外部回收商最高门店成交价1200，平台回收商最高门店成交价1000，顾客成交价800，则常规压价=1000-800=200元</div>
        </div>
      </div>
      <div v-else>
        <span>例如:外部回收商门店显示价=1500(门店成交价为报价扣除返利红包的金额)</span>
        <div class="normalShow mb-20  mt-20" style="background-color: #e4ecfd;">
          <div class="flex flex-jb">
            <span style="font-weight: 700;color: black;">顾客成交价小于平台最高回收商门店显示价时：</span> <span
              style="font-weight: 700;color: #0981ff;">外部压价金额=外部回收商报价的门店显示价-平台最高报价的门店显示价</span>
          </div>
          <div style="font-size:12px;color:#666">如顾客成交价800，平台最高回收商报价的门店显示价为1000，则外部压价金额1500-1000=500</div>
        </div>
        <div class="normalShow mb-20">
          <div class="flex flex-jb">
            <span style="font-weight: 700;color: black;">顾客成交价≥平台最高回收商门店显示价时：</span> <span
              style="font-weight: 700;color: #f76654;">外部压价金额=外部回收商报价的门店显示价-顾客成交价</span>
          </div>
          <div style="font-size:12px;color:#666">如顾客成交价1200，平台最高回收商报价的门店显示价为1000时，则外部高出金额1500-1200=300</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="calculateNormalShow = false">关闭</el-button>
      </span>
    </el-dialog>
     <!-- 压价设置-设置指定人员 -->
    <el-dialog title="设置指定人员" :visible.sync="bargainDesignatedDialogVisible" :close-on-click-modal="false"
      width="750px" @closed="bargainDesignatedDialogClosed">
      <el-table border :data="assignFounderList" class="bargain-designated-table">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="姓名" prop="staffName" align="center"></el-table-column>
        <el-table-column label="手机号" prop="mobile" align="center"></el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isMajor ? '创建人' : row.staffType == '01' ? '子账号' : row.staffType == '02' ? '总监' : row.staffType == '03' ? '店长' : '店员' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分成" align="center" width="160">
          <template slot-scope="{ row }">
            <div class="flex percent-input-wrap" style="justify-content: center">
               <span>{{row.possessRate}}</span>
              <span class="percent-symbol">%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bargainDesignatedDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { encryptByDES } from "@/utils/3DES";
import MachineTemplateList from "./components/MachineTemplateList";
export default {
  name: "Table",
  components: {
    MachineTemplateList,
  },
  data() {
    return {
      tableKey:12,
      bargainDesignatedDialogVisible: false,
      updateTime:"",
      isScollr:false,
      titleDataList: [
        {
          name: "公司利润设置",
          id: "first_li",
        },
        {
          name: "员工红包设置",
          id: "second_li",
        },
        {
          name: "管理人员提成设置",
          id: "third_li",
        },
        {
          name: "压价提成设置",
          id: "four_li",
        },
        {
          name: "收款退款设置",
          id: "five_li",
        },
        {
          name: "提现设置",
          id: "six_li",
        },
      ],
      titleIndexsel: "first_li",
      headers: {
        ACCESS_TOKEN: localStorage.getItem("token"),
        channel: "platformPc",
        TOKEN: "",
      },
      royaltyrebateType: "",
      loading: false,
      seachDataList: [],
      setType: false,
      configType: "",
      source: "",
      butLoading: false,
      withdrawalloading: false,
      number: {},
      storeNum: 0,
      companyInfo: {
        address: "",
        companyName: "",
        contact: "",
        phone: "",
      },
      isOnlineEnable: false,
      rowId: "",
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      profitMode: "", // 利润模式
      redType: "01",
      isAngPow: false,
      isManagerReward: false,
      isOpenExtraDepreciateShare: false,
      isOpenOutQuote: true,
      isOpenMiniMallShareReward: false,
      miniMallShareReward: "",
      isDepreciateShare: false,
      pageNum: 1,
      rebateAuditRole: "02",
      staffTitle: "",
      staffAddTip: "",
      command: "",
      preRebateAuditList: [],
      rebateAuditList: [],
      refundAuditDataList: [],
      dialogRuleVisible: false, // 弹框的出现与否
      commandDisableShow: false,
      calculateTitle: "",
      typeCalculate: "",
      calculateNormalShow: false, //常规压价
      calculateOutShow: false, //外部压价
      dialogCalculateOutTitle: "",
      calculateOutRuleShow: false, //外部压价设置弹框显示
      dialogRuleTitle: "", // 标题
      dialogProfitRuleTitle: "", //利润提成设置弹框标题
      dialogProfitRuleVisible: false, //利润提成设置弹框显示
      RoyaltyVisible: false, //管理人员提成
      RoyaltyRuleTitle: "",
      delDialogTitle: "删除确认",
      dialogDelVisible: false,
      storePreRebateAuditloading: false,
      storeRebateAuditloading: false,
      refundAuditListloading: false,
      tableOperation: "del",
      outTableOperation: "del",
      royaltyOperation: "del",
      rebateType: "",
      tableType: "",
      isApIntoMode: false,
      rebateTemplateList: [
        {
          templateName: "公共配置（默认）",
          regionList: [],
          storeList: [],
          machineTemplateList: [],
        },
      ], // 返利配置模板
      machineTemplateList: [], // 指定机型模版
      angPowTemplateList: [
        { templateName: "公共配置（默认）", regionList: [], storeList: [] },
      ], // 红包配置模板
      cutPriceTemplateList: [
        {
          templateName: "公共配置（默认）",
          cutPriceRegionList: [],
          extraCutPriceRegionList: [],
          storeList: [],
          isOpenExtraDepreciateShare: false,
        },
      ], // 红包配置模板
       managerTemplateList: [{ templateName: "公共配置（默认）", regionList: [], storeList: [], Commissionofficer: [], RoyaltyAuditList: [] }], // 管理人员提成配置模板
      angPowStoreList: [],
      DepreciateStoreList: [],
      manageStoreList: [],
      rebateStoreList: [],
      afterDepreciateStyle: "02",
      apIntoMode: "comp", //到账配置
      managerIntoMode: "comp", //管理者提成-到账模式（到员工账户：per,到公司账户：comp）
      Commissionofficer: [], //提成人员
      rewardLateArrivalType: "01", //到账时机
      isCutPrice: "02",
      rewardWithdrawChannel: null,
      managerRewardWithdrawChannel: "alipay", //管理者提成-奖励提现渠道(alipay:支付宝，wechat:微信)
      isStaffWithdrawalAudit: "01", //红包提现-是否审核
      accountWithdraw: "02", // 是否可提现
      isaccountWithdrawflag: false, // 是否可设置是否可提现
      arrivalMethod: "01",
      userPayeeMode: "01", // 用户收款设置
      jxyCompanyId: null, //九讯云商户
      userPayeeModeTrade: "01",
      isStaffPayUserAudit: "01", //店员付给用户-是否审核
      isRebateStore: "02", // 门店返利申请
      isRebateStoreAudit: "02", // 门店返利审核
      unUedAddToStaff: "02", //未使用加价部分是否提成给店员
      addToStaffRate: "", //未使用加价部分奖励比例(门店加价部分)
      isPreRebateStoreAudit: "02", // 预留返利审核
      isPreRebateStore: "02", // 预留返利申请
      addPriceUseType: "02", // 加价申请使用方式 01 固定比例 02 输入区间金额
      isCmccAddPrice: false, // 移动商户专用：是否使用加价券
      rebateEmbezzleMode: "ack", // 挪用时机
      addPriceSettleStyle: "01", // 结算方式
      rebateEmbezzleStaff: "", //可领取返利人员
      rebateRateMethod: "01", //返利计算方式
      rebateTypeTab: "01",
      ManagementTypeTab: "01", //管理人员提成
      rebateActiveName: "公共配置（默认）",
      angPowActiveName: "公共配置（默认）",
      DepreciateName: "公共配置（默认）",
      managerActiveName: "公共配置（默认）",
      addTemplateTitle: "", // 添加个性配置title
      addTemplateShow: false, //添加个性配置弹框显示
      addTemplateType: "", //添加个性配置类型
      angPowTypeTab: "01", // 红包金额/关联门店切换
      DepreciateTypeTab: "01", // 红包金额/关联门店切换
      storeVisible: false, //绑定门店弹框
      storeLoading: false,
      plopoeDelVisible: false, //移除提成人员
      informationDelVisible: false,
      canEnddata: {}, //提成人员信息
      isRedStoreDel: true, // 红包批量删除按钮
      isDepreciateStoreDel: true, // 红包批量删除按钮
      isRebateStoreDel: true, // 返利批量删除按钮
      isAngPowAddPrice: "02", // 红包是否能挪用加价（01 能 02 不能）
      inputTemplateName: "",
      addType: "",
      isOpenInsideBiz: null,
      refundAuditRole: "03",
      selectWithdrawal: [],
      accountWithdrawStaff: [],
      storeTagList: [], // 标签下拉
      inspectorAreaList: [], // 区域下拉
      // currentRowId: null,
      redPacketPage: {
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      staffPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      storeDialogPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      ruleForm: {
        lower: "",
        upper: "",
        rebate: "",
        delayRebate: "",
        shopownerReward: "",
        clerkReward: "",
        rebateType: "",
        shopownerRewardLimit: "",
        clerkRewardLimit: "",
        rebateLimit: "",
        delayRebateLimit: "",
        cutPriceScope: "",
        cutPriceScopeLimit: "",
      },
      profitRuleForm: {
        lower: "",
        upper: "",
        shopownerCutPrice: "",
        shopownerCutPriceLimit: "",
        clerkCutPrice: "",
        clerkCutPriceLimit: "",
      },
      RoyaltyRuleForm: {
        lower: "",
        upper: "",
        rebateType: "",
        founderReward: "",
        founderRewardLimit: "",
        inspectorReward: "",
        inspectorRewardLimit: "",
      },
      calculateOutRuleForm: {
        lower: "",
        upper: "",
        shopownerCutPrice: "",
        shopownerCutPriceLimit: "",
        clerkCutPrice: "",
        clerkCutPriceLimit: "",
      },
      storeDialogForm: {
        storeName: "",
        tagIds: [],
        inspectorIds: [],
        assignedStoreIds: [],
      },
      redPacketloading: false,
      staffListLoading: false,
      rebateloading: false,
      withdrawDialogVisible: false,
      staffDialogVisible: false,
      RoyaltyDialogVisible: false,
      staffDialogVisible2: false,
      importDialogVisible: false,
      isSelection: true,
      redPacketColumns: [
        { slotName: "rank" },
        { slotName: "shopownerReward" },
        { slotName: "shopownerRewardLimit" },
        { slotName: "clerkReward" },
        { slotName: "clerkRewardLimit" },
        { slotName: "operation" },
      ],
      angPowStoreColumns: [
        { slotName: "areaName" },
        { slotName: "storeName" },
        { slotName: "storeManager" },
        { slotName: "tagList" },
        { slotName: "operation" },
      ],
      rebateColumns: [
        { slotName: "rank" },
        { slotName: "rebate" },
        { slotName: "rebateLimit" },
        { slotName: "delayRebate" },
        { slotName: "delayRebateLimit" },
        { slotName: "cutPriceScope" },
        { slotName: "cutPriceScopeLimit" },
        { slotName: "operation" },
      ],
      withdrawalColumns: [
        { label: "提现人", prop: "staffName" },
        { label: "联系电话", prop: "staffMobile" },
        { slotName: "isSubscribe" },
        { label: "微信昵称", prop: "nickName" },
        { slotName: "headImg" },
        { slotName: "operation" },
      ],
      storePreRebateAuditColumns: [
        { label: "审核人", prop: "staffName" },
        { label: "联系电话", prop: "staffMobile" },
        { slotName: "staffType" },
        { slotName: "isSubscribe" },
        { slotName: "operation" },
      ],
      CommissionColumns: [
        { label: "以下人员可获得提成", prop: "staffName" },
        { slotName: "staffMobile" },
        { slotName: "staffType" },
        { slotName: "possessRate" },
        { slotName: "operation" },
      ],
      staffListColumns: [
        { label: "审核人", prop: "staffName" },
        { label: "联系电话", prop: "staffMobile" },
        { slotName: "staffType" },
        { slotName: "isSubscribe" },
      ],
      RoyaltystaffColumns: [
        { label: "姓名", prop: "staffName" },
        { label: "电话", prop: "staffMobile" },
        { slotName: "staffType" },
      ],
      staffListWithdrawalColumns: [
        // { slotName: "radioSelect" },
        { label: "提现人", prop: "staffName" },
        { label: "联系电话", prop: "staffMobile" },
        { slotName: "staffType" },
        { slotName: "isSubscribe" },
        { label: "微信昵称", prop: "nickName" },
        { slotName: "headImg" },
      ],
      storeDialogTableColumns: [
        { slotName: "areaName" },
        { slotName: "storeName" },
        { slotName: "tagList" },
      ],
      profitPacketColumns: [
        { slotName: "rank" },
        { slotName: "shopownerCutPrice" },
        { slotName: "shopownerCutPriceLimit" },
        { slotName: "clerkCutPrice" },
        { slotName: "clerkCutPriceLimit" },
        { slotName: "operation" },
      ],
      RoyaltySelectdata: [],
      storeDialogDataList: [],
      rebateRegionList: [],
      staffListData: [],
      RoyaltystaffListData: [],
      withdrawalDataList: [],
      storePreRebateAuditList: [],
      storeRebateAuditList: [],
      refundAuditList: [],
      RoyaltyAuditList: [],
      selectStaffList: [],
      selectAddStoreList: [],
      rebatePage: {
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      apRegionList: [],
      assignFounderList: [],
      cutPriceRegionList: [],
      extraCutPriceRegionList: [],
      RoyaltyRegionList: [],
      rules: {
        lower: [
          { required: true, message: "请输入报价区间起始值", trigger: "blur" },
        ],
        upper: [
          { required: true, message: "请输入报价区间结束值", trigger: "blur" },
        ],
        rebate: [
          { required: true, message: "请输入返利比例", trigger: "blur" },
        ],
        delayRebate: [
          { required: true, message: "请输入返利预留比例", trigger: "blur" },
        ],
        rebateType: [
          { required: true, message: "请选择返利方式", trigger: "change" },
        ],
        shopownerReward: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        clerkReward: [{ required: true, message: "请输入", trigger: "blur" }],
        shopownerRewardLimit: [
          { required: true, message: "输入店长红包上限金额", trigger: "blur" },
        ],
        clerkRewardLimit: [
          { required: true, message: "输入店员红包上限金额", trigger: "blur" },
        ],
        delayRebateLimit: [
          { required: true, message: "输入预留返利上限金额", trigger: "blur" },
        ],
        rebateLimit: [
          { required: true, message: "输入门店返利上限金额", trigger: "blur" },
        ],
        cutPriceScope: [
          { required: true, message: "请输入弹性比例", trigger: "blur" },
        ],
        cutPriceScopeLimit: [
          { required: true, message: "输入弹性上限金额", trigger: "blur" },
        ],
      },
      profitRules: {
        lower: [
          {
            required: true,
            message: "请输入差价利润区间起始值",
            trigger: "blur",
          },
        ],
        upper: [
          {
            required: true,
            message: "请输入差价利润区间结束值",
            trigger: "blur",
          },
        ],
        shopownerCutPrice: [
          { required: true, message: "请输入店长差价提成", trigger: "blur" },
        ],
        shopownerCutPriceLimit: [
          {
            required: true,
            message: "输入店长差价提成上限金额",
            trigger: "blur",
          },
        ],
        clerkCutPrice: [
          { required: true, message: "请输入店员差价提成", trigger: "blur" },
        ],
        clerkCutPriceLimit: [
          {
            required: true,
            message: "输入店员差价提成上限金额",
            trigger: "blur",
          },
        ],
      },
      RoyaltyRules: {
        lower: [
          { required: true, message: "请输入报价区间起始值", trigger: "blur" },
        ],
        upper: [
          { required: true, message: "请输入报价区间结束值", trigger: "blur" },
        ],
        rebateType: [
          { required: true, message: "请选择返利方式", trigger: "change" },
        ],
        founderReward: [
          {
            required: true,
            message: "请输入创建人及子账号提成",
            trigger: "blur",
          },
        ],
        founderRewardLimit: [
          {
            required: true,
            message: "请输入创建人及子账号提成上限",
            trigger: "blur",
          },
        ],
        inspectorReward: [
          { required: true, message: "请输入总监提成", trigger: "blur" },
        ],
        inspectorRewardLimit: [
          { required: true, message: "请输入总监提成上限", trigger: "blur" },
        ],
      },
      calculateOutRules: {
        lower: [
          {
            required: true,
            message: "请输入高出金额区间起始值",
            trigger: "blur",
          },
        ],
        upper: [
          {
            required: true,
            message: "请输入高出金额区间结束值",
            trigger: "blur",
          },
        ],
        shopownerCutPrice: [
          { required: true, message: "请输入店长差价提成", trigger: "blur" },
        ],
        shopownerCutPriceLimit: [
          {
            required: true,
            message: "输入店长差价提成上限金额",
            trigger: "blur",
          },
        ],
        clerkCutPrice: [
          { required: true, message: "请输入店员差价提成", trigger: "blur" },
        ],
        clerkCutPriceLimit: [
          {
            required: true,
            message: "输入店员差价提成上限金额",
            trigger: "blur",
          },
        ],
      },
      isDisabled: false,
      isuserPayeeModeTrade: false, //以旧换新是否可付款禁用 2.2.1.1
      isStaffPayUserAuditdis: false, //是否需要审核禁用
      isHistory: false,
    };
  },
  computed: {},
  mounted(){
   
  },
  created() {
    _api.getPayMode().then((res) => {
      this.companyId = res.data.companyId;
      this.source = res.data.payMode;
      if (this.source == "online") {
        _api.configInfoNew().then((res) => {
          if (res.code === 1) {
            this.updateTime=res.data.updateTime
            this.companyInfo.address = res.data.address;
            this.companyInfo.companyName = res.data.companyName;
            this.companyInfo.contact = res.data.contact;
            this.companyInfo.phone = res.data.phone;
            this.isOnlineEnable = res.data.isOnlineEnable;
            this.rewardWithdrawChannel = res.data.rewardWithdrawChannel;
            this.storeNum = res.data.storeNum;
            this.setType = res.data.profitMode ? "true" : "false";
            this.isOpenInsideBiz = res.data.isOpenInsideBiz;
            this.userPayeeMode = res.data.userPayeeMode || "01";
            if (res.data.jxyCompanyId) {
              console.log("jiuxunyun1");
              this.jxyCompanyId = res.data.jxyCompanyId;
              //支持可付款给用户
              this.apIntoMode = "comp";
              this.managerIntoMode = "comp";
              this.isDisabled = true;
              if (this.userPayeeMode == "01" && this.jxyCompanyId) {
                this.isuserPayeeModeTrade = true;
                this.userPayeeModeTrade = "01";
                this.isStaffPayUserAuditdis = true;
                this.isStaffPayUserAudit = "02";
              }
            }
            if (this.$route.query.type == "true" || res.data.profitMode) {
               this.managerRewardWithdrawChannel =
                  res.data.managerRewardWithdrawChannel;
              this.profitMode = res.data.profitMode;
              (this.afterDepreciateStyle = res.data.afterDepreciateStyle),
                (this.apIntoMode = res.data.apIntoMode);
              this.rewardLateArrivalType = res.data.rewardLateArrivalType;
              this.isApIntoMode = res.data.apIntoMode ? true : false;
              this.isAngPow = res.data.isAngPow == "01";
              this.isManagerReward = res.data.isManagerReward == "01"; //	管理者提成-是否打开（开启：01，关闭：02）
              this.isOpenMiniMallShareReward =
                res.data.isOpenMiniMallShareReward == "01";
              this.isOpenOutQuote = res.data.isOpenOutQuote;
              this.miniMallShareReward = res.data.miniMallShareReward;
              this.isCutPrice = res.data.isCutPrice || "02";
              this.isDepreciateShare = res.data.isDepreciateShare == "01";
              (this.isStaffWithdrawalAudit =
                res.data.isStaffWithdrawalAudit || "01"),
                (this.isStaffPayUserAudit =
                  res.data.isStaffPayUserAudit || "01"),
                (this.userPayeeModeTrade = res.data.userPayeeModeTrade || "01"),
                //
                (this.angPowTemplateList =
                  res.data.angPowTemplateList || this.angPowTemplateList);
              if (
                res.data.angPowTemplateList &&
                res.data.angPowTemplateList.length
              ) {
                this.apRegionList =
                  res.data.angPowTemplateList[0].regionList || [];
                this.redPacketPage.total =
                  res.data.angPowTemplateList[0].regionList &&
                  res.data.angPowTemplateList[0].regionList.length
                    ? res.data.angPowTemplateList[0].regionList.length
                    : 0;
                this.rebateType = res.data.angPowTemplateList[0].regionList
                  ? res.data.angPowTemplateList[0].regionList[0].rebateType
                  : "";
                this.isAngPowAddPrice =
                  res.data.angPowTemplateList[0].isAngPowAddPrice || "02";
              }
              //利润提成
              this.cutPriceTemplateList =
                res.data.cutPriceTemplateList || this.cutPriceTemplateList;
              if (
                res.data.cutPriceTemplateList &&
                res.data.cutPriceTemplateList.length
              ) {
                this.cutPriceRegionList =
                  res.data.cutPriceTemplateList[0].cutPriceRegionList || [];
                this.extraCutPriceRegionList =
                  res.data.cutPriceTemplateList[0].extraCutPriceRegionList ||
                  [];
                this.isOpenExtraDepreciateShare =
                  res.data.cutPriceTemplateList[0].isOpenExtraDepreciateShare ==
                  "01";
                  this.assignFounderList =res.data.cutPriceTemplateList[0].assignFounderList || [];
              }
              this.managerTemplateList= res.data.managerRewardTemplateList || this.managerRewardTemplateList;
               // 管理人员提成回填（从顶层 managerRewardTemplateList）
              if (res.data.managerRewardTemplateList && res.data.managerRewardTemplateList.length) {
                this.managerTemplateList = res.data.managerRewardTemplateList.map(item => {
                  let officer = [];
                  if (item.isManagerAssignFounder == '01') officer.push('2');
                  if (item.isManagerInspector == '01') officer.push('1');
                  return {
                    templateName: item.templateName,
                    isDefault: item.isDefault,
                    managerRewardRegionList: item.managerRewardRegionList || [],
                    storeList: item.storeList || [],
                    Commissionofficer: officer,
                    assignFounderList: item.assignFounderList || [],
                  };
                });
                const def = this.managerTemplateList[0];
                console.log(def,"def0999999999999999");
                this.Commissionofficer = def.assignFounderList||[];
                this.RoyaltyRegionList = def.managerRewardRegionList || [];
                this.manageStoreList = def.storeList || [];
              }
              //
              this.rebateTemplateList =
                res.data.rebateTemplateList || this.rebateTemplateList;
              if (
                res.data.rebateTemplateList &&
                res.data.rebateTemplateList.length
              ) {
                res.data.rebateTemplateList.forEach((item) => {
                  if (
                    item.storeRebateAuditList &&
                    item.storeRebateAuditList.length
                  ) {
                    item.rebateAuditList = [];
                    item.storeRebateAuditList.forEach((ele) => {
                      item.rebateAuditList.push({
                        auditType: "01",
                        staffId: ele.staffId,
                      });
                    });
                  }
                  if (
                    item.storePreRebateAuditList &&
                    item.storePreRebateAuditList.length
                  ) {
                    item.preRebateAuditList = [];
                    item.storePreRebateAuditList.forEach((ele) => {
                      item.preRebateAuditList.push({
                        auditType: "02",
                        staffId: ele.staffId,
                      });
                    });
                  }
                });
                this.rebateRegionList =
                  res.data.rebateTemplateList[0].regionList || [];
                this.machineTemplateList =
                  res.data.rebateTemplateList[0].machineTemplateList || [];
                this.rebatePage.total =
                  res.data.rebateTemplateList[0].regionList &&
                  res.data.rebateTemplateList[0].regionList.length
                    ? res.data.rebateTemplateList[0].regionList.length
                    : 0;
                this.isRebateStore =
                  res.data.rebateTemplateList[0].isRebateStore;
                this.isRebateStoreAudit =
                  res.data.rebateTemplateList[0].isRebateStoreAudit || "02";
                this.unUedAddToStaff =
                  res.data.rebateTemplateList[0].unUedAddToStaff || "02";
                this.addToStaffRate =
                  res.data.rebateTemplateList[0].addToStaffRate || "";
                this.rebateAuditRole =
                  res.data.rebateTemplateList[0].rebateAuditRole;
                this.isPreRebateStore =
                  res.data.rebateTemplateList[0].isPreRebateStore;
                this.addPriceUseType =
                  res.data.rebateTemplateList[0].addPriceUseType;
                this.isCmccAddPrice =
                  res.data.rebateTemplateList[0].isCmccAddPrice || false;
                this.isPreRebateStoreAudit =
                  res.data.rebateTemplateList[0].isPreRebateStoreAudit || "02";
                if (
                  res.data.rebateTemplateList[0].storePreRebateAuditList &&
                  res.data.rebateTemplateList[0].storePreRebateAuditList.length
                ) {
                  res.data.rebateTemplateList[0].storePreRebateAuditList.forEach(
                    (item) => {
                      item.staffMobile = item.mobile;
                      this.preRebateAuditList.push({
                        auditType: "02",
                        staffId: item.staffId,
                      });
                    }
                  );
                  this.storePreRebateAuditList =
                    res.data.rebateTemplateList[0].storePreRebateAuditList;
                }
                if (
                  res.data.rebateTemplateList[0].storeRebateAuditList &&
                  res.data.rebateTemplateList[0].storeRebateAuditList.length
                ) {
                  res.data.rebateTemplateList[0].storeRebateAuditList.forEach(
                    (item) => {
                      item.staffMobile = item.mobile;
                      this.rebateAuditList.push({
                        auditType: "01",
                        staffId: item.staffId,
                      });
                    }
                  );
                  this.storeRebateAuditList =
                    res.data.rebateTemplateList[0].storeRebateAuditList;
                }
              }
              //是否可设置提现
              this.isaccountWithdrawflag =
                res.data.accountWithdraw == "01" ? false : true;
              this.accountWithdraw = res.data.accountWithdraw;
              console.log(res.data.accountWithdrawStaffInfo);
              if (res.data.accountWithdrawStaffInfo) {
                res.data.accountWithdrawStaffInfo.staffMobile =
                  res.data.accountWithdrawStaffInfo.mobile;
                res.data.accountWithdrawStaffInfo.forEach((item) => {
                  item.staffMobile = item.mobile;
                  this.accountWithdrawStaff.push(item.staffId);
                });
                this.withdrawalDataList = res.data.accountWithdrawStaffInfo;
              }
              this.refundAuditRole = res.data.refundAuditRole;
              this.rebateEmbezzleMode = res.data.rebateEmbezzleMode;
              this.addPriceSettleStyle = res.data.addPriceSettleStyle;
              this.rebateEmbezzleStaff = res.data.rebateEmbezzleStaff;
              if (res.data.refundAuditList && res.data.refundAuditList.length) {
                res.data.refundAuditList.forEach((item) => {
                  item.staffMobile = item.mobile;
                  this.refundAuditDataList.push({
                    auditType: "03",
                    staffId: item.staffId,
                  });
                });
                this.refundAuditList = res.data.refundAuditList;
              }
              this.rebateRateMethod = res.data.rebateRateMethod;
              this.arrivalMethod = res.data.arrivalMethod;
            }
          }
        });
      } else {
        _api.configInfoOffLineNew().then((res) => {
          if (res.code === 1) {
            console.log(res);
            this.updateTime=res.data.updateTime
            this.companyInfo.address = res.data.address;
            this.companyInfo.companyName = res.data.companyName;
            this.companyInfo.contact = res.data.contact;
            this.companyInfo.phone = res.data.phone;
            (this.isOnlineEnable = res.data.isOnlineEnable),
              (this.setType = res.data.profitMode ? "true" : "false");
            this.isOpenInsideBiz = res.data.isOpenInsideBiz;
            this.userPayeeMode = res.data.userPayeeMode || "01";
            if (res.data.jxyCompanyId) {
              this.jxyCompanyId = res.data.jxyCompanyId;
              this.apIntoMode = "comp";
              this.managerIntoMode = "comp";
              this.isDisabled = true;
              if (this.userPayeeMode == "01" && this.jxyCompanyId) {
                this.isuserPayeeModeTrade = true;
                this.userPayeeModeTrade = "01";
                this.isStaffPayUserAuditdis = true;
                this.isStaffPayUserAudit = "02";
              }
            }
            if (this.$route.query.type == "true" || res.data.profitMode) {
              (this.afterDepreciateStyle = res.data.afterDepreciateStyle),
                (this.isAngPow = res.data.isAngPow == "01");
              this.isOpenMiniMallShareReward =
                res.data.isOpenMiniMallShareReward == "01";
              this.isOpenOutQuote = res.data.isOpenOutQuote;
              this.miniMallShareReward = res.data.miniMallShareReward;
              this.isCutPrice = res.data.isCutPrice || "02";
              this.isDepreciateShare = res.data.isDepreciateShare == "01";
              this.apRegionList = res.data.apRegionList || [];
              this.redPacketPage.total =
                res.data.apRegionList && res.data.apRegionList.length
                  ? res.data.apRegionList.length
                  : 0;
              this.rebateType = res.data.apRegionList
                ? res.data.apRegionList[0].rebateType
                : "";
              this.rebateRegionList = res.data.rebateRegionList || [];
              this.rebatePage.total =
                res.data.rebateRegionList && res.data.rebateRegionList.length
                  ? res.data.rebateRegionList.length
                  : 0;
              this.isPreRebateStoreAudit =
                res.data.isPreRebateStoreAudit || "02";
              this.isRebateStore = res.data.isRebateStore;
              this.isAngPowAddPrice = res.data.isAngPowAddPrice || "02";
              this.isRebateStoreAudit = res.data.isRebateStoreAudit || "02";
              this.unUedAddToStaff = res.data.unUedAddToStaff || "02";
              this.addToStaffRate = res.data.addToStaffRate || "";
              this.profitMode = res.data.profitMode;
              this.isPreRebateStore = res.data.isPreRebateStore;
              this.addPriceUseType = res.data.addPriceUseType || "02";
              this.isCmccAddPrice = res.data.isCmccAddPrice || false;
              this.rebateAuditRole = res.data.rebateAuditRole;
              if (
                res.data.storePreRebateAuditList &&
                res.data.storePreRebateAuditList.length
              ) {
                res.data.storePreRebateAuditList.forEach((item) => {
                  item.staffMobile = item.mobile;
                  this.preRebateAuditList.push({
                    auditType: "02",
                    staffId: item.staffId,
                  });
                });
                this.storePreRebateAuditList = res.data.storePreRebateAuditList;
              }
              if (
                res.data.storeRebateAuditList &&
                res.data.storeRebateAuditList.length
              ) {
                res.data.storeRebateAuditList.forEach((item) => {
                  item.staffMobile = item.mobile;
                  this.rebateAuditList.push({
                    auditType: "01",
                    staffId: item.staffId,
                  });
                });
                this.storeRebateAuditList = res.data.storeRebateAuditList;
              }
              if (
                res.data.cutPriceRegionList &&
                res.data.cutPriceRegionList.length
              ) {
                this.cutPriceRegionList = res.data.cutPriceRegionList;
              }
              if (
                res.data.extraCutPriceRegionList &&
                res.data.extraCutPriceRegionList.length
              ) {
                this.extraCutPriceRegionList = res.data.extraCutPriceRegionList;
              }
              this.rebateRateMethod = res.data.rebateRateMethod;
            }
          }
        });
      }
    });
  },
  watch: {
    apRegionList(val) {
      if (!val.length) {
        this.rebateType = "";
      }
    },
    RoyaltyRegionList(val) {
      if (!val.length) {
        this.royaltyrebateType = "";
      }
    },
    isRebateStore(val) {
      if (val == "02") {
        this.isPreRebateStore = "02";
        this.unUedAddToStaff = "02";
      }
      if (val == "01" && this.isOpenInsideBiz) {
        this.isPreRebateStore = "01";
        this.addPriceUseType = "02";
        this.isCmccAddPrice = false;
      }
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.isRebateStore = val;
        }
      });
    },
    unUedAddToStaff(val) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.unUedAddToStaff = val;
        }
      });
    },
    addToStaffRate(val) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.addToStaffRate = val;
        }
      });
    },
    isAngPowAddPrice(val) {
      this.angPowTemplateList.forEach((item) => {
        if (item.templateName == this.angPowActiveName) {
          item.isAngPowAddPrice = val;
        }
      });
    },
    isPreRebateStore(val) {
      if (val == "02") {
        this.isPreRebateStoreAudit = "02";
      }
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.isPreRebateStore = val;
        }
      });
    },
    isAngPow(val) {
      if (this.setType == "false") {
        if (!val) {
          this.apIntoMode = "";
        } else {
          this.apIntoMode = "comp";
        }
      } else {
        if (!this.isApIntoMode && val) {
          this.apIntoMode = "comp";
        } else if (!this.isApIntoMode && !val) {
          this.apIntoMode = "";
        }
      }
    },
    addPriceSettleStyle(val) {
    },
    storePreRebateAuditList(arr) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.storePreRebateAuditList = arr;
        }
      });
    },
    storeRebateAuditList(arr) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.storeRebateAuditList = arr;
        }
      });
    },
    preRebateAuditList(arr) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.preRebateAuditList = arr;
        }
      });
    },
    rebateAuditList(arr) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.rebateAuditList = arr;
        }
      });
    },
    rebateActiveName(val) {
      this.rebateTypeTab = "01";
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == val) {
          this.rebateRegionList =
            JSON.parse(JSON.stringify(item.regionList)) || [];

          this.rebatePage.total =
            item.regionList && item.regionList.length
              ? item.regionList.length
              : 0;
          this.machineTemplateList =
            JSON.parse(JSON.stringify(item.machineTemplateList)) || [];
          this.isRebateStore = item.isRebateStore || "02";
          this.isRebateStoreAudit = item.isRebateStoreAudit || "02";
          this.unUedAddToStaff = item.unUedAddToStaff || "02";
          this.addToStaffRate = item.addToStaffRate || "";
          this.rebateAuditRole = item.rebateAuditRole || "02";
          this.isPreRebateStore = item.isPreRebateStore || "02";
          this.addPriceUseType = item.addPriceUseType || "02";
          this.isCmccAddPrice = item.isCmccAddPrice || false;
          this.isPreRebateStoreAudit = item.isPreRebateStoreAudit || "02";
          if (
            item.storePreRebateAuditList &&
            item.storePreRebateAuditList.length
          ) {
            item.storePreRebateAuditList.forEach((ele) => {
              ele.staffMobile = ele.mobile;
              this.preRebateAuditList.push({
                auditType: "02",
                staffId: ele.staffId,
              });
            });
            this.storePreRebateAuditList = item.storePreRebateAuditList;
          } else {
            (this.preRebateAuditList = []), (this.storePreRebateAuditList = []);
          }
          if (item.storeRebateAuditList && item.storeRebateAuditList.length) {
            item.storeRebateAuditList.forEach((ele) => {
              ele.staffMobile = ele.mobile;
              this.rebateAuditList.push({
                auditType: "01",
                staffId: ele.staffId,
              });
            });
            console.log(item.storeRebateAuditList);
            this.storeRebateAuditList = item.storeRebateAuditList;
          } else {
            (this.rebateAuditList = []), (this.storeRebateAuditList = []);
          }
          this.rebateStoreList =
            JSON.parse(JSON.stringify(item.storeList)) || [];
        }
      });
    },
    angPowActiveName(val) {
      console.log(this.angPowTemplateList);
      this.angPowTypeTab = "01";
      this.angPowTemplateList.forEach((item) => {
        if (item.templateName == val) {
          console.log(item.regionList);
          this.apRegionList = JSON.parse(JSON.stringify(item.regionList)) || [];
          this.redPacketPage.total =
            item.regionList && item.regionList.length
              ? item.regionList.length
              : 0;
          this.rebateType = item.regionList.length
            ? item.regionList[0].rebateType
            : "";
          this.angPowStoreList =
            JSON.parse(JSON.stringify(item.storeList)) || [];
          this.isAngPowAddPrice = item.isAngPowAddPrice || "02";
        }
      });
    },
    isOpenExtraDepreciateShare(val) {
      console.log(val, "waibu1利润提成");
      this.cutPriceTemplateList.forEach((item) => {
        if (item.templateName == this.DepreciateName) {
          item.isOpenExtraDepreciateShare = val === true ? "01" : "02";
        }
      });
    },
    DepreciateName(val) {
      console.log(this.cutPriceTemplateList);
      this.DepreciateTypeTab = "01";
      this.cutPriceTemplateList.forEach((item) => {
        if (item.templateName == val) {
          console.log(item);
          this.cutPriceRegionList =
            JSON.parse(JSON.stringify(item.cutPriceRegionList)) || [];
             this.assignFounderList =
            JSON.parse(JSON.stringify(item.assignFounderList)) || [];
          this.extraCutPriceRegionList =
            JSON.parse(JSON.stringify(item.extraCutPriceRegionList)) || [];
          this.DepreciateStoreList =
            JSON.parse(JSON.stringify(item.storeList)) || [];
          this.isOpenExtraDepreciateShare =
            item.isOpenExtraDepreciateShare == "01";
        }
      });
    },
     managerActiveName(val) {
      console.log(this.managerTemplateList);
      this.ManagementTypeTab = "01";
      this.managerTemplateList.forEach((item) => {
        if (item.templateName == val) {
          console.log(item);
          this.Commissionofficer =
            JSON.parse(JSON.stringify(item.assignFounderList)) || [];
          this.RoyaltyRegionList =
            JSON.parse(JSON.stringify(item.managerRewardRegionList)) || [];
           this.manageStoreList =
            JSON.parse(JSON.stringify(item.storeList)) || [];
        }
      });
    },
    DepreciateStoreList(arr) {
      if (!arr.length) {
        this.isDepreciateStoreDel = true;
      }
    },
    DepreciateTypeTab(val) {
      this.selectStoreDelList = [];
      this.isDepreciateStoreDel = true;
    },
    angPowStoreList(arr) {
      if (!arr.length) {
        this.isRedStoreDel = true;
      }
    },
    angPowTypeTab(val) {
      this.selectStoreDelList = [];
      this.isRedStoreDel = true;
    },
    rebateStoreList(arr) {
      if (!arr.length) {
        this.isRebateStoreDel = true;
      }
    },
    rebateTypeTab(val) {
      this.selectStoreDelList = [];
      this.isRebateStoreDel = true;
    },
    isRebateStoreAudit(val) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.isRebateStoreAudit = val;
        }
      });
    },
    rebateAuditRole(val) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.rebateAuditRole = val;
        }
      });
    },
    addPriceUseType(val) {
      if (val === "01") {
        this.isCmccAddPrice = false;
      }
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.addPriceUseType = val;
        }
      });
    },
    isCmccAddPrice(val) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.isCmccAddPrice = val;
        }
      });
    },
    isPreRebateStoreAudit(val) {
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName == this.rebateActiveName) {
          item.isPreRebateStoreAudit = val;
        }
      });
    },
    afterDepreciateStyle(val) {
      if (val == "02") {
        this.isCutPrice = "02";
      }
    },
  },
  methods: {
     // 指定人员设置弹窗关闭
    bargainDesignatedDialogClosed() {
      // this.assignFounderList = [];
    },
     // 打开指定人员设置弹窗（点击自定义表头）
    openBargainDesignatedDialog() {
      this.bargainDesignatedDialogVisible = true;
    },
    handleContainerScroll() {
      const scrollTop = this.$refs.scrollContainer.scrollTop
    },
    seeDetailed(data) {
      // this.isScollr=true
      const element = document.getElementById(data);
      element.scrollIntoView({ behavior: "smooth" });
    },
    actionTitleId(id) {
      this.titleIndexsel =id;
      this.seeDetailed(id)
    },
    setChange(val) {
      if (!val) {
        this.isOpenExtraDepreciateShare = false;
      }
    },
    addCulateRule() {
      return (
        <div>
          <span>常规压价金额</span>
          <el-button
            type="danger"
            plain
            style="padding:3px;margin-left:5px"
            size="mini"
            //加入点击事件---------
            onClick={() => this.calculate("normal")}
            //---------------------
          >
            计算方式
          </el-button>
        </div>
      );
    },
    addCulateRule1() {
      return (
        <div>
          <span>外部压价金额</span>
          <el-button
            type="danger"
            plain
            style="padding:3px;margin-left:5px"
            size="mini"
            //加入点击事件---------
            onClick={() => this.calculate("out")}
            //---------------------
          >
            计算方式
          </el-button>
        </div>
      );
    },
    calculate(type) {
      this.typeCalculate = type;
      this.calculateTitle = type == "normal" ? "常规压价金额" : "外部压价金额";
      this.calculateNormalShow = true;
    },
    // 显示添加规则弹框
    addRule(type) {
      if (type != "profit") {
        this.configType = type;
        this.rowId = "";
        if (type == "red") {
          this.ruleForm.rebateType = this.rebateType;
          this.dialogRuleTitle = "添加规则-红包设置";
        } else {
          this.dialogRuleTitle = "添加规则-返利设置";
        }
        this.dialogRuleVisible = true;
      } else {
        this.rowId = "";
        this.dialogProfitRuleTitle = "添加规则-差价提成设置";
        this.dialogProfitRuleVisible = true;
      }
    },
    //管理人员提成规则添加
    addRoyaltyRule() {
      if (
        this.Commissionofficer.includes("1") &&
        this.Commissionofficer.length === 1
      ) {
        this.RoyaltyRuleForm.founderReward = 0;
        this.RoyaltyRuleForm.founderRewardLimit = 0;
      } else if (
        this.Commissionofficer.includes("2") &&
        this.Commissionofficer.length === 1
      ) {
        this.RoyaltyRuleForm.inspectorReward = 0;
        this.RoyaltyRuleForm.inspectorRewardLimit = 0;
      }
      if (this.RoyaltyRegionList.length) {
        this.royaltyrebateType = this.RoyaltyRegionList[0].rebateType;
        this.RoyaltyRuleForm.rebateType = this.RoyaltyRegionList[0].rebateType;
      }
      this.RoyaltyVisible = true;
      this.RoyaltyRuleTitle = "添加规则";
    },
    addRuleOut() {
      this.rowId = "";
      this.dialogCalculateOutTitle = "添加规则-外部压价设置";
      this.calculateOutRuleShow = true;
    },
    ruleDialogClosed() {
      this.tableOperation = "del";
      this.ruleForm = {
        lower: "",
        upper: "",
        rebate: "",
        delayRebate: "",
        shopownerReward: "",
        clerkReward: "",
        rebateType: "",
        shopownerRewardLimit: "",
        clerkRewardLimit: "",
        rebateLimit: "",
        delayRebateLimit: "",
        cutPriceScope: "",
        cutPriceScopeLimit: "",
      };
      this.$refs["ruleForm"].resetFields();
    },
    // 利润提成设置弹框关闭
    profitRuleDialogClosed() {
      this.tableOperation = "del";
      this.profitRuleForm = {
        lower: "",
        upper: "",
        shopownerCutPrice: "",
        shopownerCutPriceLimit: "",
        clerkCutPrice: "",
        clerkCutPriceLimit: "",
      };
      this.$refs["profitRuleForm"].resetFields();
    },
    // 管理人员提成设置弹框关闭
    RoyaltyClosed() {
      this.royaltyOperation = "del";
      this.RoyaltyRuleForm = {
        lower: "",
        upper: "",
        rebateType: "",
        founderReward: "",
        founderRewardLimit: "",
        inspectorReward: "",
        inspectorRewardLimit: "",
      };
      this.rowId = "";
      this.$refs["RoyaltyRuleForm"].resetFields();
    },

    // 利润提成设置弹框关闭
    calculateOutRuleDialogClosed() {
      this.outTableOperation = "del";
      this.calculateOutRuleForm = {
        lower: "",
        upper: "",
        shopownerCutPrice: "",
        shopownerCutPriceLimit: "",
        clerkCutPrice: "",
        clerkCutPriceLimit: "",
      };
      this.$refs["calculateOutRuleForm"].resetFields();
    },
    //添加提成人员
    addassign() {
      this.administrationstaffListChange();
      this.RoyaltyDialogVisible = true;
    },
    pelplochange(e) {
      console.log(e);
    },
    //移除提成人员
    detaleAction(data) {
      this.canEnddata = data;
      this.plopoeDelVisible = true;
    },
    //确认删除
    SuccessactionDel() {
      this.RoyaltyAuditList = this.RoyaltyAuditList.filter(
        (item) => item.staffId != this.canEnddata.staffId
      );
      this.plopoeDelVisible = false;
    },
    informationSuccessDel() {
      this.RoyaltyRegionList = this.RoyaltyRegionList.filter(
        (item) => item.id != this.rowId
      );
      this.informationDelVisible = false;
      this.rowId = "";
    },
    delDialogClosed() {
      this.dialogDelVisible = false;
      this.butLoading = false;
    },
    handleClose() {
      this.dialogRuleVisible = false;
      this.dialogDelVisible = false;
    },
    // 弹框规则确认
    handleSuccess() {
      console.log(this.ruleForm);
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let ruleForm = this.ruleForm;
          console.log(ruleForm);
          if (Number(ruleForm.lower) > Number(ruleForm.upper)) {
            this.$message.error("起始值不能大于结束值");
            return;
          }
          if (Number(ruleForm.lower) == Number(ruleForm.upper)) {
            this.$message.error("起始值不能和结束值相等");
            return;
          }
          let params = {
            rank: ruleForm.lower + "≤区间" + ruleForm.upper,
            lower: ruleForm.lower,
            upper: ruleForm.upper,
          };
          if (this.configType == "rebate") {
            if (this.rebateRegionList.length && this.tableOperation != "edit") {
              let numArr = [];
              this.rebateRegionList.forEach((item) => {
                numArr.push(item.lower);
                numArr.push(item.upper);
              });
              let iMin = Math.min(...numArr); //最小值
              let iMAX = Math.max(...numArr); //最大值
              if (ruleForm.upper != iMin && ruleForm.lower != iMAX) {
                this.$message.error("价位区间不连续");
                return;
              }
              if (ruleForm.lower != iMAX && ruleForm.upper != iMin) {
                this.$message.error("价位区间不连续");
                return;
              }
            }
            params.rebate = ruleForm.rebate;
            params.delayRebate = ruleForm.delayRebate;
            params.rebateLimit = ruleForm.rebateLimit;
            params.delayRebateLimit = ruleForm.delayRebateLimit;
            params.cutPriceScope = ruleForm.cutPriceScope;
            params.cutPriceScopeLimit = ruleForm.cutPriceScopeLimit;
            params.configType = "01";
            if (this.rowId.toString()) {
              this.rebateRegionList.splice(this.rowId, 1, params);
              this.rebateTemplateList.forEach((item) => {
                if (item.templateName == this.rebateActiveName) {
                  item.regionList = this.rebateRegionList;
                }
              });
            } else {
              this.rebateRegionList.push(params);
              this.rebateTemplateList.forEach((item) => {
                if (item.templateName == this.rebateActiveName) {
                  item.regionList = this.rebateRegionList;
                }
              });
            }
            this.rebatePage.total = this.rebateRegionList.length;
          } else {
            if (this.apRegionList.length && this.tableOperation != "edit") {
              let numArr = [];
              this.apRegionList.forEach((item) => {
                numArr.push(item.lower);
                numArr.push(item.upper);
              });
              let iMin = Math.min(...numArr); //最小值
              let iMAX = Math.max(...numArr); //最大值
              if (ruleForm.upper != iMin && ruleForm.lower != iMAX) {
                this.$message.error("价位区间不连续");
                return;
              }
              if (ruleForm.lower != iMAX && ruleForm.upper != iMin) {
                this.$message.error("价位区间不连续");
                return;
              }
            }
            this.rebateType = ruleForm.rebateType;
            params.rebateType = ruleForm.rebateType;
            params.shopownerReward = ruleForm.shopownerReward;
            params.shopownerRewardLimit =
              ruleForm.rebateType == "01"
                ? ruleForm.shopownerRewardLimit
                : ruleForm.shopownerReward;
            params.clerkReward = ruleForm.clerkReward;
            params.clerkRewardLimit =
              ruleForm.rebateType == "01"
                ? ruleForm.clerkRewardLimit
                : ruleForm.clerkReward;
            params.configType = "02";
            console.log(params);
            if (this.rowId.toString()) {
              this.apRegionList.splice(this.rowId, 1, params);
              this.angPowTemplateList.forEach((item) => {
                if (item.templateName == this.angPowActiveName) {
                  item.regionList = this.apRegionList;
                }
              });
            } else {
              this.apRegionList.push(params);
              this.angPowTemplateList.forEach((item) => {
                if (item.templateName === this.angPowActiveName) {
                  item.regionList = this.apRegionList;
                }
              });
            }
            this.redPacketPage.total = this.apRegionList.length;
          }
          this.dialogRuleVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    calculateOutHandleSuccess() {
      this.$refs["calculateOutRuleForm"].validate((valid) => {
        if (valid) {
          let calculateOutRuleForm = this.calculateOutRuleForm;
          console.log(calculateOutRuleForm);
          if (
            Number(calculateOutRuleForm.lower) >
            Number(calculateOutRuleForm.upper)
          ) {
            this.$message.error("起始值不能大于结束值");
            return;
          }
          if (
            Number(calculateOutRuleForm.lower) ==
            Number(calculateOutRuleForm.upper)
          ) {
            this.$message.error("起始值不能和结束值相等");
            return;
          }
          let params = {
            lower: calculateOutRuleForm.lower,
            upper: calculateOutRuleForm.upper,
          };
          if (
            this.extraCutPriceRegionList.length &&
            this.outTableOperation != "edit"
          ) {
            let numArr = [];
            this.extraCutPriceRegionList.forEach((item) => {
              numArr.push(item.lower);
              numArr.push(item.upper);
            });
            let iMin = Math.min(...numArr); //最小值
            let iMAX = Math.max(...numArr); //最大值
            if (
              calculateOutRuleForm.upper != iMin &&
              calculateOutRuleForm.lower != iMAX
            ) {
              this.$message.error("价位区间不连续");
              return;
            }
            if (
              calculateOutRuleForm.lower != iMAX &&
              calculateOutRuleForm.upper != iMin
            ) {
              this.$message.error("价位区间不连续");
              return;
            }
          }
          params.shopownerCutPrice = calculateOutRuleForm.shopownerCutPrice;
          params.shopownerCutPriceLimit =
            calculateOutRuleForm.shopownerCutPriceLimit;
          params.clerkCutPrice = calculateOutRuleForm.clerkCutPrice;
          params.clerkCutPriceLimit = calculateOutRuleForm.clerkCutPriceLimit;
          params.configType = "03";
          if (this.rowId.toString()) {
            this.extraCutPriceRegionList.splice(this.rowId, 1, params);
            this.cutPriceTemplateList.forEach((item) => {
              if (item.templateName === this.DepreciateName) {
                item.extraCutPriceRegionList = this.extraCutPriceRegionList;
              }
            });
          } else {
            this.extraCutPriceRegionList.push(params);
            this.cutPriceTemplateList.forEach((item) => {
              if (item.templateName === this.DepreciateName) {
                item.extraCutPriceRegionList = this.extraCutPriceRegionList;
              }
            });
          }
          this.calculateOutRuleShow = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    profitHandleSuccess() {
      this.$refs["profitRuleForm"].validate((valid) => {
        if (valid) {
          let profitRuleForm = this.profitRuleForm;
          console.log(profitRuleForm);
          if (Number(profitRuleForm.lower) > Number(profitRuleForm.upper)) {
            this.$message.error("起始值不能大于结束值");
            return;
          }
          if (Number(profitRuleForm.lower) == Number(profitRuleForm.upper)) {
            this.$message.error("起始值不能和结束值相等");
            return;
          }
          let params = {
            lower: profitRuleForm.lower,
            upper: profitRuleForm.upper,
          };
          if (this.cutPriceRegionList.length && this.tableOperation != "edit") {
            let numArr = [];
            this.cutPriceRegionList.forEach((item) => {
              numArr.push(item.lower);
              numArr.push(item.upper);
            });
            let iMin = Math.min(...numArr); //最小值
            let iMAX = Math.max(...numArr); //最大值
            if (profitRuleForm.upper != iMin && profitRuleForm.lower != iMAX) {
              this.$message.error("价位区间不连续");
              return;
            }
            if (profitRuleForm.lower != iMAX && profitRuleForm.upper != iMin) {
              this.$message.error("价位区间不连续");
              return;
            }
          }
          params.shopownerCutPrice = profitRuleForm.shopownerCutPrice;
          params.shopownerCutPriceLimit = profitRuleForm.shopownerCutPriceLimit;
          params.clerkCutPrice = profitRuleForm.clerkCutPrice;
          params.clerkCutPriceLimit = profitRuleForm.clerkCutPriceLimit;
          params.configType = "03";
          if (this.rowId.toString()) {
            this.cutPriceRegionList.splice(this.rowId, 1, params);
            this.cutPriceTemplateList.forEach((item) => {
              if (item.templateName === this.DepreciateName) {
                item.cutPriceRegionList = this.cutPriceRegionList;
              }
            });
          } else {
            this.cutPriceRegionList.push(params);
            this.cutPriceTemplateList.forEach((item) => {
              if (item.templateName === this.DepreciateName) {
                item.cutPriceRegionList = this.cutPriceRegionList;
              }
            });
          }
          this.dialogProfitRuleVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //管理人员提成规则
    RoyaltyHandleSuccess() {
      this.$refs["RoyaltyRuleForm"].validate((valid) => {
        if (valid) {
          let RoyaltyRuleForm = this.RoyaltyRuleForm;
          console.log(RoyaltyRuleForm);
          if (Number(RoyaltyRuleForm.lower) > Number(RoyaltyRuleForm.upper)) {
            this.$message.error("起始值不能大于结束值");
            return;
          }
          if (Number(RoyaltyRuleForm.lower) == Number(RoyaltyRuleForm.upper)) {
            this.$message.error("起始值不能和结束值相等");
            return;
          }
          let params = {
            lower: RoyaltyRuleForm.lower,
            upper: RoyaltyRuleForm.upper,
          };
          if (
            this.RoyaltyRegionList.length &&
            this.royaltyOperation != "edit"
          ) {
            let numArr = [];
            this.RoyaltyRegionList.forEach((item) => {
              numArr.push(item.lower);
              numArr.push(item.upper);
            });
            let iMin = Math.min(...numArr); //最小值
            let iMAX = Math.max(...numArr); //最大值
            if (
              RoyaltyRuleForm.upper != iMin &&
              RoyaltyRuleForm.lower != iMAX
            ) {
              this.$message.error("价位区间不连续");
              return;
            }
            if (
              RoyaltyRuleForm.lower != iMAX &&
              RoyaltyRuleForm.upper != iMin
            ) {
              this.$message.error("价位区间不连续");
              return;
            }
          }
          params.rebateType = RoyaltyRuleForm.rebateType;
          params.founderReward = RoyaltyRuleForm.founderReward;
          params.inspectorReward = RoyaltyRuleForm.inspectorReward;
          // 判断按固定金额返回（02）或者按比例返回（01）
          params.founderRewardLimit =
            RoyaltyRuleForm.rebateType == "01"
              ? RoyaltyRuleForm.founderRewardLimit
              : RoyaltyRuleForm.founderReward;
          params.inspectorRewardLimit =
            RoyaltyRuleForm.rebateType == "01"
              ? RoyaltyRuleForm.inspectorRewardLimit
              : RoyaltyRuleForm.inspectorReward;
          if (this.rowId) {
            params.id = this.rowId;
            this.RoyaltyRegionList.splice(
              this.RoyaltyRegionList.findIndex(
                (item) => item.configId == this.rowId
              ),
              1,
              params
            );
          } else {
            params.id = Number(params.lower) + 1;
            this.RoyaltyRegionList.push(params);
          }
          this.rowId = "";
          this.RoyaltyVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 红包设置切换tab
    redBtnClick(type) {
      this.redType = type;
    },
    // 返利设置切换tab
    rebateBtnClick(type) {
      this.rebateTypeTab = type;
    },
    //管理人员提成设置
    ManageBtnClick(type) {
      if (
        this.Commissionofficer.length === 0 &&
        (type == "02" || type == "03")
      ) {
        return this.$message.error("请先设置指定提成人员！");
      }
      this.ManagementTypeTab = type;
    },
    angPowBtnClick(type) {
      this.angPowTypeTab = type;
    },
    DepreciateBtnClick(type) {
      this.DepreciateTypeTab = type;
    },
    redHandleCurrentChange(val) {
      this.redPacketPage.pageNum = val;
    },
    rebateHandleCurrentChange(val) {
      this.rebatePage.pageNum = val;
    },
    handleBtn(row, type, tab, index) {
      console.log(row, type, tab, index);
      this.rowId = index;
      this.tableType = tab;
      this.tableOperation = type;
      if (type == "del") {
        if (tab == "examine") {
          this.delDialogTitle = "移除审核人";
        } else {
          this.delDialogTitle = "删除确认";
        }
        this.dialogDelVisible = true;
      } else {
        this.ruleForm.lower = row.lower;
        this.ruleForm.upper = row.upper;
        if (tab == "rebate") {
          this.rowId =
            index + (this.rebatePage.pageNum - 1) * this.rebatePage.pageSize;
          this.configType = "rebate";
          this.dialogRuleTitle = "编辑规则-返利设置";
          this.ruleForm.rebate = row.rebate;
          this.ruleForm.delayRebate = row.delayRebate;
          this.ruleForm.rebateLimit = row.rebateLimit;
          this.ruleForm.delayRebateLimit = row.delayRebateLimit;
          this.ruleForm.cutPriceScope = row.cutPriceScope;
          this.ruleForm.cutPriceScopeLimit = row.cutPriceScopeLimit;
        } else {
          this.rowId =
            index +
            (this.redPacketPage.pageNum - 1) * this.redPacketPage.pageSize;
          this.configType = "red";
          this.dialogRuleTitle = "编辑规则-红包设置";
          this.ruleForm.rebateType = this.rebateType;
          this.ruleForm.shopownerReward = row.shopownerReward;
          this.ruleForm.clerkReward = row.clerkReward;
          this.ruleForm.shopownerRewardLimit = row.shopownerRewardLimit;
          this.ruleForm.clerkRewardLimit = row.clerkRewardLimit;
        }
        console.log(this.ruleForm);
        this.dialogRuleVisible = true;
      }
    },
    //管理人员规则操作
    RoyaltyHandleBtn(row, type, index) {
      console.log(row);
      this.rowId = row.id;
      this.royaltyOperation = type;
      if (type == "del") {
        this.informationDelVisible = true;
      } else {
        this.RoyaltyRuleForm.lower = row.lower;
        this.RoyaltyRuleForm.upper = row.upper;
        this.RoyaltyRuleTitle = "编辑规则";
        this.RoyaltyRuleForm.rebateType = row.rebateType;
        this.RoyaltyRuleForm.founderReward = row.founderReward;
        this.RoyaltyRuleForm.founderRewardLimit = row.founderRewardLimit;
        this.RoyaltyRuleForm.inspectorReward = row.inspectorReward;
        this.RoyaltyRuleForm.inspectorRewardLimit = row.inspectorRewardLimit;
        this.RoyaltyVisible = true;
      }
    },
    outCalculateHandleBtn(row, type, index) {
      this.rowId = index;
      this.tableType = "out";
      this.outTableOperation = type;
      if (type == "del") {
        this.delDialogTitle = "删除确认";
        this.dialogDelVisible = true;
      } else {
        this.calculateOutRuleForm.lower = row.lower;
        this.calculateOutRuleForm.upper = row.upper;
        this.dialogProfitRuleTitle = "编辑规则-外部压价提成设置";
        this.calculateOutRuleForm.shopownerCutPrice = row.shopownerCutPrice;
        this.calculateOutRuleForm.shopownerCutPriceLimit =
          row.shopownerCutPriceLimit;
        this.calculateOutRuleForm.clerkCutPrice = row.clerkCutPrice;
        this.calculateOutRuleForm.clerkCutPriceLimit = row.clerkCutPriceLimit;
        this.calculateOutRuleShow = true;
      }
    },
    profitHandleBtn(row, type, index) {
      this.rowId = index;
      this.tableType = "profit";
      this.tableOperation = type;
      if (type == "del") {
        this.delDialogTitle = "删除确认";
        this.dialogDelVisible = true;
      } else {
        this.profitRuleForm.lower = row.lower;
        this.profitRuleForm.upper = row.upper;
        this.dialogProfitRuleTitle = "编辑规则-差价提成设置";
        this.profitRuleForm.shopownerCutPrice = row.shopownerCutPrice;
        this.profitRuleForm.shopownerCutPriceLimit = row.shopownerCutPriceLimit;
        this.profitRuleForm.clerkCutPrice = row.clerkCutPrice;
        this.profitRuleForm.clerkCutPriceLimit = row.clerkCutPriceLimit;
        this.dialogProfitRuleVisible = true;
      }
    },
    handleSuccessDel() {
      if (this.tableType == "red") {
        let changeArr = this.apRegionList.slice(
          (this.redPacketPage.pageNum - 1) * this.redPacketPage.pageSize,
          this.redPacketPage.pageNum * this.redPacketPage.pageSize
        );
        changeArr.splice(this.rowId, 1);
        this.apRegionList = this.apRegionList
          .slice(
            0,
            (this.redPacketPage.pageNum - 1) * this.redPacketPage.pageSize
          )
          .concat(changeArr);
        this.redPacketPage.total = this.apRegionList.length;
        if (!changeArr.length) {
          this.redPacketPage.pageNum =
            this.redPacketPage.pageNum > 1
              ? this.redPacketPage.pageNum - 1
              : this.redPacketPage.pageNum;
        }
        this.angPowTemplateList.forEach((item) => {
          if (item.templateName === this.angPowActiveName) {
            item.regionList = this.apRegionList;
          }
        });
      } else if (this.tableType == "rebate") {
        let changeArr = this.rebateRegionList.slice(
          (this.rebatePage.pageNum - 1) * this.rebatePage.pageSize,
          this.rebatePage.pageNum * this.rebatePage.pageSize
        );
        changeArr.splice(this.rowId, 1);
        this.rebateRegionList = this.rebateRegionList
          .slice(0, (this.rebatePage.pageNum - 1) * this.rebatePage.pageSize)
          .concat(changeArr);
        this.rebatePage.total = this.rebateRegionList.length;
        if (!changeArr.length) {
          this.rebatePage.pageNum =
            this.rebatePage.pageNum > 1
              ? this.rebatePage.pageNum - 1
              : this.rebatePage.pageNum;
        }
        this.rebateTemplateList.forEach((item) => {
          if (item.templateName === this.rebateActiveName) {
            item.regionList = this.rebateRegionList;
          }
        });
      } else if (this.tableType == "examine") {
        this.storePreRebateAuditList.splice(this.rowId, 1);
        this.preRebateAuditList = [];
        this.storePreRebateAuditList.forEach((item) => {
          this.preRebateAuditList.push({
            auditType: "02",
            staffId: item.staffId,
          });
        });
      } else if (this.tableType == "examineStore") {
        this.storeRebateAuditList.splice(this.rowId, 1);
        this.rebateAuditList = [];
        this.storeRebateAuditList.forEach((item) => {
          this.rebateAuditList.push({
            auditType: "01",
            staffId: item.staffId,
          });
        });
      } else if (this.tableType == "withdrawal") {
        this.withdrawalDataList.splice(this.rowId, 1);
        this.accountWithdrawStaff = [];
        this.withdrawalDataList.forEach((item) => {
          this.accountWithdrawStaff.push(item.staffId);
        });
        // this.currentRowId = null
      } else if (this.tableType == "examineRefund") {
        this.refundAuditList.splice(this.rowId, 1);
        this.refundAuditDataList = [];
        this.refundAuditList.forEach((item) => {
          this.refundAuditDataList.push({
            auditType: "03",
            staffId: item.staffId,
          });
        });
      } else if (this.tableType == "redStore") {
        this.angPowStoreList.splice(this.rowId, 1);
        this.angPowTemplateList.forEach((item) => {
          if (item.templateName === this.angPowActiveName) {
            item.storeList = this.angPowStoreList;
          }
        });
      } else if (this.tableType == "batchRed") {
        let idArr = this.selectStoreDelList.map((item) => item.id);
        this.angPowStoreList = this.angPowStoreList.filter(
          (ele) => !idArr.includes(ele.id)
        );
        this.angPowTemplateList.forEach((item) => {
          if (item.templateName === this.angPowActiveName) {
            item.storeList = this.angPowStoreList;
          }
        });
        this.isRedStoreDel = true;
      } else if (this.tableType == "redConfig") {
        this.angPowTemplateList.splice(
          this.angPowTemplateList.findIndex(
            (v) => v.templateName === this.angPowActiveName
          ),
          1
        );
        this.angPowActiveName = "公共配置（默认）";
      } else if (this.tableType == "DepreciateStore") {
        this.DepreciateStoreList.splice(this.rowId, 1);
        this.cutPriceTemplateList.forEach((item) => {
          if (item.templateName === this.DepreciateName) {
            item.storeList = this.DepreciateStoreList;
          }
        });
      } else if (this.tableType == "batchDepreciate") {
        let idArr = this.selectStoreDelList.map((item) => item.id);
        this.DepreciateStoreList = this.DepreciateStoreList.filter(
          (ele) => !idArr.includes(ele.id)
        );
        this.cutPriceTemplateList.forEach((item) => {
          if (item.templateName === this.DepreciateName) {
            item.storeList = this.DepreciateStoreList;
          }
        });
        this.isRedStoreDel = true;
      } else if (this.tableType == "DepreciateConfig") {
        this.cutPriceTemplateList.splice(
          this.cutPriceTemplateList.findIndex(
            (v) => v.templateName === this.DepreciateName
          ),
          1
        );
        this.DepreciateName = "公共配置（默认）";
      } else if (this.tableType == "rebateConfig") {
        this.rebateTemplateList.splice(
          this.rebateTemplateList.findIndex(
            (v) => v.templateName === this.rebateActiveName
          ),
          1
        );
        this.rebateActiveName = "公共配置（默认）";
      } else if (this.tableType == "batchRebate") {
        let idArr = this.selectStoreDelList.map((item) => item.id);
        this.rebateStoreList = this.rebateStoreList.filter(
          (ele) => !idArr.includes(ele.id)
        );
        this.rebateTemplateList.forEach((item) => {
          if (item.templateName === this.rebateActiveName) {
            item.storeList = this.rebateStoreList;
          }
        });
        this.isRebateStoreDel = true;
      } else if (this.tableType == "rebateStore") {
        this.rebateStoreList.splice(this.rowId, 1);
        this.rebateTemplateList.forEach((item) => {
          if (item.templateName === this.rebateActiveName) {
            item.storeList = this.rebateStoreList;
          }
        });
      } else if (this.tableType == "profit") {
        this.cutPriceRegionList.splice(this.rowId, 1);
        this.cutPriceTemplateList.forEach((item) => {
          if (item.templateName === this.DepreciateName) {
            item.cutPriceRegionList = this.cutPriceRegionList;
          }
        });
      } else if (this.tableType == "out") {
        this.extraCutPriceRegionList.splice(this.rowId, 1);
        this.cutPriceTemplateList.forEach((item) => {
          if (item.templateName === this.DepreciateName) {
            item.extraCutPriceRegionList = this.extraCutPriceRegionList;
          }
        });
      }
      this.dialogDelVisible = false;
    },
    // 回显显示效果
    toggleSelection(rows) {
      console.log(rows);
      Promise.resolve().then(() => {
        if (rows && rows.length) {
          rows.forEach((row) => {
            console.log(row);
            this.$refs.multipleTable.setSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 添加提现人
    addWithdraw(type) {
      this.addType = type;
      this.staffListChange();
      this.selectStaffList = [];
      if (type == "01") {
        this.selectStaffList.push(...this.withdrawalDataList);
        this.staffDialogVisible2 = true;
        this.staffTitle = "添加提现人";
        this.staffAddTip =
          "说明: 提现人员仅返回创建者及子账号角色的有效账号数据（最多可选择3人提现）";
        // this.isSelection = true
      } else if (type == "02") {
        this.selectStaffList.push(...this.storePreRebateAuditList);
        this.staffDialogVisible = true;
        this.staffTitle = "添加审核人";
        this.staffAddTip =
          "说明: 预留返利审核人仅返回创建者及子账号角色的有效账号数据";
        // this.isSelection = true
      } else if (type == "03") {
        this.selectStaffList.push(...this.storeRebateAuditList);
        this.staffDialogVisible = true;
        this.staffTitle = "添加审核人";
        this.staffAddTip =
          "说明: 门店返利审核人仅返回创建者及子账号角色的有效账号数据";
        // this.isSelection = true
      } else if (type == "04") {
        this.selectStaffList.push(...this.refundAuditList);
        this.staffDialogVisible = true;
        this.staffTitle = "添加审核人";
        this.staffAddTip =
          "说明: 退款审核人仅返回创建者及子账号角色的有效账号数据";
      }
    },
    //管理人员提成指定人员
    administrationstaffListChange(val) {
      if (val) {
        this.staffPage.pageNum = val;
      } else {
        this.staffPage.pageNum = 1;
      }
      this.staffListLoading = true;
      const baseRequest = {
        staffTypes: ["01"],
        isEnable: true,
        isQuit: false,
        companyId: this.companyId,
        pageNum: 1,
        pageSize: 99999,
      };
      _api.getStaffList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.RoyaltystaffListData = res.data.records;
          this.staffPage.total = res.data.total;
          this.staffPage.pageNum = res.data.current;
          this.staffListLoading = false;
          //回显已选提成指定人员
          if (this.RoyaltyAuditList.length > 0) {
            let arralldata = [];
            this.RoyaltyAuditList.forEach((irem) => {
              this.RoyaltystaffListData.forEach((iremx) => {
                if (iremx.staffId === irem.staffId) {
                  arralldata.push(iremx);
                }
              });
            });
            this.RoyaltySelectdata = arralldata;
            this.$nextTick(() => {
              arralldata.forEach((irem) => {
                this.$refs.multipleTable.$refs.tableGroup.toggleRowSelection(
                  irem
                );
              });
            });
          } else {
            this.RoyaltySelectdata = this.RoyaltyAuditList;
          }
        }
      });
    },
    staffListChange(val) {
      if (val) {
        this.staffPage.pageNum = val;
      } else {
        this.staffPage.pageNum = 1;
      }
      this.staffListLoading = true;
      const baseRequest = {
        staffTypes: ["01"],
        isEnable: true,
        isQuit: false,
        companyId: this.companyId,
        pageNum: this.staffPage.pageNum,
        pageSize: this.staffPage.pageSize,
      };
      _api.getStaffList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.staffListData = res.data.records;
          this.staffPage.total = res.data.total;
          this.staffPage.pageNum = res.data.current;
          this.staffListLoading = false;
          let _rows = [];
          this.staffListData.forEach((item) => {
            if (
              this.selectStaffList.some((ele) => ele.staffId == item.staffId)
            ) {
              _rows.push(item);
            }
            return item;
          });
          this.toggleSelection(_rows);
        }
      });
    },
    // 切换单选框
    changeRedio(event, row) {
      this.selectWithdrawal = [];
      console.log("event,row:", event, row);
      this.currentRowId = event;
      this.selectWithdrawal.push(row);
    },
    //选择指定提成人员
    RoyaltystaffSelect(e) {
      console.log(e);
      this.RoyaltySelectdata = e;
    },
    handleSelect(e) {
      console.log(e);
      this.selectStaffList = this.selectStaffList.filter((item) => {
        return !this.staffListData.some((ee) => ee.staffId == item.staffId);
      });
      let jsonArr = e;
      let newJson = this.selectStaffList; //盛放去重后数据的新数组
      for (let item1 of jsonArr) {
        //循环json数组对象的内容
        let flag = true; //建立标记，判断数据是否重复，true为不重复
        for (let item2 of newJson) {
          //循环新数组的内容
          if (item1.staffId == item2.staffId) {
            //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
            flag = false;
          }
        }
        if (flag) {
          //判断是否重复
          newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
        }
      }
      this.selectList = newJson;
      if (this.selectList.length >= 3 && this.addType == "01") {
        // 截取前3位
        this.selectStaffList = [];
        this.selectList = newJson.slice(0, 3);
        // 截取3位之后的数组  禁止选中
        let tempArr = newJson.slice(3);
        if (tempArr.length !== 0) {
          this.$message.warning("最多只能选择3个提现人");
          tempArr.forEach((ele) => {
            this.$refs.multipleTable.setSelection(ele, false);
          });
        }
      }
      this.selectStaffList.push(...this.selectList);
      let obj = {};
      let peon = this.selectStaffList.reduce((cur, next) => {
        obj[next.staffId] ? "" : (obj[next.staffId] = true && cur.push(next));
        return cur;
      }, []);
      this.selectStaffList = peon;
      console.log(this.selectStaffList);
    },
    // 管理人员提成
    adRoyaltySuccess() {
      if (this.RoyaltySelectdata.length == 0) {
        return this.$message.warning("请选择管理人员");
      } else if (this.RoyaltySelectdata.length > 3) {
        return this.$message.warning("最多只能添加3个管理人员");
      } else {
        this.RoyaltyAuditList = this.RoyaltySelectdata;
        // //去重后加入
        // const uniqueArr = this.RoyaltyAuditList.filter(
        //   (item, index) =>
        //     this.RoyaltyAuditList.findIndex(
        //       (i) => i.staffId === item.staffId
        //     ) === index
        // );
        // this.RoyaltyAuditList = uniqueArr;
        this.RoyaltyDialogVisible = false;
      }
    },
    // 提现人/审核人添加
    addHandleSuccess(type) {
      if (type == "01") {
        if (this.addType == "02") {
          this.preRebateAuditList = [];
          let selectStaffList = this.selectStaffList;
          this.storePreRebateAuditList = selectStaffList;
          this.storePreRebateAuditList.forEach((item) => {
            this.preRebateAuditList.push({
              auditType: "02",
              staffId: item.staffId,
            });
          });
        } else if (this.addType == "03") {
          this.rebateAuditList = [];
          let selectStaffList = this.selectStaffList;
          this.storeRebateAuditList = selectStaffList;
          this.storeRebateAuditList.forEach((item) => {
            this.rebateAuditList.push({
              auditType: "01",
              staffId: item.staffId,
            });
          });
        } else if (this.addType == "04") {
          this.refundAuditDataList = [];
          let selectStaffList = this.selectStaffList;
          this.refundAuditList = selectStaffList;
          this.refundAuditList.forEach((item) => {
            this.refundAuditDataList.push({
              auditType: "03",
              staffId: item.staffId,
            });
          });
        }
      } else {
        this.accountWithdrawStaff = [];
        let selectStaffList = this.selectStaffList;
        this.withdrawalDataList = selectStaffList;
        this.withdrawalDataList.forEach((item) => {
          this.accountWithdrawStaff.push(item.staffId);
        });
      }
      this.staffDialogVisible = false;
      this.staffDialogVisible2 = false;
    },
    staffDialogClosed() {
      this.selectStaffList = [];
      this.RoyaltystaffListData = [];
    },
    // 提现人/审核人添加取消
    addClosed() {
      this.staffDialogVisible = false;
      this.staffDialogVisible2 = false;
    },
    commandDialogClosed() {
      this.commandDisableShow = false;
      this.command = "";
    },
    // 确认
    confirmBtn() {
      if (!this.rewardWithdrawChannel && this.apIntoMode === "per") {
        return this.$message.error("请选择员工提现到账方式");
      }
      // if(this.apIntoMode  !== 'per'){
      //   this.rewardWithdrawChannel = null;
      // }
      if (!this.profitMode) {
        this.$message.error("请选择利润模式");
        return false;
      }
      // if (this.isAngPow && !this.apRegionList.length) {
      //   this.$message.error("红包设置开启状态必须配置金额");
      //   return false;
      // }
      if (this.source == "online" && !this.refundAuditList.length) {
        this.$message.error("退款指定审核人员不能为空");
        return false;
      }
      if (
        this.source == "online" &&
        this.accountWithdraw == "01" &&
        !this.withdrawalDataList.length
      ) {
        this.$message.error("可提现状态必须配置提现人");
        return false;
      }
      //管理人员提成
      if (this.isManagerReward) {
        if (this.Commissionofficer.length === 0) {
          return this.$message.error("请选择发放提成人员");
        }
        if (
          this.Commissionofficer.includes("2") &&
          this.RoyaltyAuditList.length === 0
        ) {
          return this.$message.error("请添加指定提成人员");
        }
        if (this.RoyaltyRegionList.length === 0) {
          return this.$message.error("请添加提成规则");
        }
      }
      // if (
      //   this.profitMode == "after" &&
      //   this.isPreRebateStoreAudit == "01" &&
      //   !this.storePreRebateAuditList.length
      // ) {
      //   this.$message.error("预留返利需审核状态必须添加审核人");
      //   return false;
      // }
      // if (
      //   this.profitMode == "after" &&
      //   this.isRebateStore == '01' &&
      //   this.isRebateStoreAudit == "01" &&
      //   !this.storeRebateAuditList.length
      // ) {
      //   this.$message.error("门店返利需审核状态必须添加审核人");
      //   return false;
      // }
      this.commandDisableShow = true;
    },
    // 设置差价利润弹性比例点击
    isCutPriceClick(e) {
      if (this.afterDepreciateStyle == "02") {
        this.$message.warning("请先选择支持降价成交");
      }
    },
    commandDisableSure() {
      if (!this.command) {
        this.$message.error("请输入谷歌验证码");
        return;
      }
      console.log(this.angPowTemplateList);
      console.log(this.rebateTemplateList);
      let angPowArr = [];
      this.angPowTemplateList.forEach((item) => {
        angPowArr.push({
          isDefault: item.templateName == "公共配置（默认）",
          regionList: item.regionList,
          storeIds:
            item.storeList && item.storeList.length
              ? item.storeList.map((item) => item.id)
              : [],
          templateName: item.templateName,
          isAngPowAddPrice: item.isAngPowAddPrice || "02",
        });
      });
      let DepreciateArr = [];
      this.cutPriceTemplateList.forEach((item) => {
        DepreciateArr.push({
          isDefault: item.templateName == "公共配置（默认）",
          cutPriceRegionList: item.cutPriceRegionList,
          extraCutPriceRegionList: item.extraCutPriceRegionList,
          storeIds:
            item.storeList && item.storeList.length
              ? item.storeList.map((item) => item.id)
              : [],
          templateName: item.templateName,
          isOpenExtraDepreciateShare: item.isOpenExtraDepreciateShare,
        });
      });
      console.log(DepreciateArr, "利润提成设置");
      let rebateArr = [];
      this.rebateTemplateList.forEach((item) => {
        rebateArr.push({
          isDefault: item.templateName == "公共配置（默认）",
          regionList: item.regionList,
          storeIds:
            item.storeList && item.storeList.length
              ? item.storeList.map((item) => item.id)
              : [],
          templateName: item.templateName,
          addPriceUseType: item.addPriceUseType || "02",
          isCmccAddPrice: item.isCmccAddPrice || false,
          isPreRebateStore: item.isPreRebateStore || "02",
          isPreRebateStoreAudit: item.isPreRebateStoreAudit || "02",
          isRebateStore: item.isRebateStore || "02",
          isRebateStoreAudit: item.isRebateStoreAudit || "02",
          unUedAddToStaff: item.unUedAddToStaff || "02",
          addToStaffRate: item.addToStaffRate || "",
          preRebateAuditList: item.preRebateAuditList || [],
          rebateAuditList: item.rebateAuditList || [],
          rebateAuditRole: item.rebateAuditRole || "",
          machineTemplateList: item.machineTemplateList || [],
        });
      });
      if (this.source == "online") {
        let baseRequest = {
          cutPriceTemplateList: DepreciateArr, //利润提成
          companyId: this.companyId,
          command: this.command,
          accountWithdraw: this.accountWithdraw,
          accountWithdrawStaff: this.accountWithdrawStaff,
          addPriceSettleStyle: this.addPriceSettleStyle,
          afterDepreciateStyle: this.afterDepreciateStyle,
          apIntoMode: this.apIntoMode,
          rewardLateArrivalType: this.rewardLateArrivalType,
          // cutPriceRegionList: this.cutPriceRegionList,
          // extraCutPriceRegionList: this.extraCutPriceRegionList,
          isAngPow: this.isAngPow ? "01" : "02",
          isOpenMiniMallShareReward: this.isOpenMiniMallShareReward
            ? "01"
            : "02",
          isOpenOutQuote: this.isOpenOutQuote,
          miniMallShareReward: this.miniMallShareReward,
          isCutPrice: this.isCutPrice,
          isDepreciateShare: this.isDepreciateShare ? "01" : "02",
          isStaffWithdrawalAudit: this.isStaffWithdrawalAudit,
          isStaffPayUserAudit: this.isStaffPayUserAudit,
          profitMode: this.profitMode,
          rebateEmbezzleMode: this.rebateEmbezzleMode,
          rebateEmbezzleStaff: this.rebateEmbezzleStaff,
          refundAuditList: this.refundAuditDataList,
          refundAuditRole: this.refundAuditRole,
          userPayeeMode: this.userPayeeMode,
          userPayeeModeTrade: this.userPayeeModeTrade,
          angPowTemplateList: angPowArr,
          rebateRateMethod: this.rebateRateMethod,
          rebateTemplateList: rebateArr,
          arrivalMethod: this.arrivalMethod,
          managerReward: null,
          isManagerReward: "02",
          rewardWithdrawChannel:
            this.apIntoMode === "comp" ? "wechat" : this.rewardWithdrawChannel,
        };
        if (this.isManagerReward) {
          (baseRequest.isManagerReward = this.isManagerReward ? "01" : "02"),
            (baseRequest.managerReward = {
              assignFounderList: this.Commissionofficer.includes("2")
                ? this.RoyaltyAuditList
                : [], //指定提成人
              managerRewardRegionList: this.RoyaltyRegionList, //管理者提成区间配置
              isManagerAssignFounder: this.Commissionofficer.includes("2")
                ? "01"
                : "02", //管理者提成-是否指派提成人（是：01，否：02）
              isManagerInspector: this.Commissionofficer.includes("1")
                ? "01"
                : "02", //	管理者提成-总监是否可以提成（是：01，否：02）
              managerIntoMode: this.managerIntoMode, //	管理者提成-到账模式（到员工账户：per,到公司账户：comp）
              managerRewardWithdrawChannel: this.managerRewardWithdrawChannel, //	管理者提成-奖励提现渠道(alipay:支付宝，wechat:微信)
            });
          if (baseRequest.managerReward.assignFounderList.length > 0) {
            baseRequest.managerReward.assignFounderList = baseRequest.managerReward.assignFounderList.map(
              (item) => item.staffId
            );
          }
        }
        console.log(baseRequest);
        if (this.setType == "true") {
          _api.editOnlinePayConfig(baseRequest).then((res) => {
            if (res.code === 1) {
              this.$message.success("修改成功");
              if (this.$route.query.goback) {
                this.$store.state.tagsView.visitedViews.splice(
                  this.$store.state.tagsView.visitedViews.findIndex(
                    (item) => item.path === this.$route.path
                  ),
                  1
                );
                this.$router.push({ path: "/StoreShop/index" });
              } else {
                this.$router.go(-1);
              }
            }
          });
        } else {
          _api.addOnlinePayConfig(baseRequest).then((res) => {
            if (res.code === 1) {
              this.$message.success("设置成功");
              if (this.$route.query.goback) {
                this.$store.state.tagsView.visitedViews.splice(
                  this.$store.state.tagsView.visitedViews.findIndex(
                    (item) => item.path === this.$route.path
                  ),
                  1
                );
                this.$router.push({ path: "/StoreShop/index" });
              } else {
                this.$router.go(-1);
              }
            }
          });
        }
      } else {
        let baseRequest = {
          cutPriceTemplateList: DepreciateArr, //利润提成
          apRegionList: this.apRegionList,
          // cutPriceRegionList: this.cutPriceRegionList,
          // extraCutPriceRegionList: this.extraCutPriceRegionList,
          command: this.command,
          companyId: this.companyId,
          isAngPow: this.isAngPow ? "01" : "02",
          isOpenMiniMallShareReward: this.isOpenMiniMallShareReward
            ? "01"
            : "02",
          isOpenOutQuote: this.isOpenOutQuote,
          miniMallShareReward: this.miniMallShareReward,
          isCutPrice: this.isCutPrice,
          isDepreciateShare: this.isDepreciateShare ? "01" : "02",
          afterDepreciateStyle: this.afterDepreciateStyle,
          isPreRebateStore: this.isPreRebateStore,
          addPriceUseType: this.addPriceUseType,
          isCmccAddPrice: this.isCmccAddPrice,
          isPreRebateStoreAudit: this.isPreRebateStoreAudit,
          isRebateStore: this.isRebateStore,
          isAngPowAddPrice: this.isAngPowAddPrice,
          isRebateStoreAudit: this.isRebateStoreAudit,
          unUedAddToStaff: this.unUedAddToStaff,
          addToStaffRate: this.addToStaffRate,
          preRebateAuditList: this.preRebateAuditList,
          rebateAuditList: this.rebateAuditList,
          profitMode: this.profitMode,
          rebateAuditRole: this.rebateAuditRole,
          rebateRegionList: this.rebateRegionList,
          rebateRateMethod: this.rebateRateMethod,
        };
        if (this.setType == "true") {
          _api.editOfflinePayConfig(baseRequest).then((res) => {
            if (res.code === 1) {
              this.$message.success("修改成功");
              this.$store.state.tagsView.visitedViews.splice(
                this.$store.state.tagsView.visitedViews.findIndex(
                  (item) => item.path === this.$route.path
                ),
                1
              );
              this.$router.push({ path: "/StoreShop/index" });
            }
          });
        } else {
          _api.addOfflinePayConfig(baseRequest).then((res) => {
            if (res.code === 1) {
              this.$message.success("设置成功");
              this.$store.state.tagsView.visitedViews.splice(
                this.$store.state.tagsView.visitedViews.findIndex(
                  (item) => item.path === this.$route.path
                ),
                1
              );
              this.$router.push({ path: "/StoreShop/index" });
            }
          });
        }
      }
    },
    // 返回
    goBack() {
      this.$router.go(-1);
    },
    // 单选取消
    rebateAuditRoleClick(e) {
      console.log(e);
      this.rebateAuditRole = e == this.rebateAuditRole ? "" : e;
    },
    // 单选取消
    refundAuditRoleClick(e) {
      console.log(e);
      this.refundAuditRole = e == this.refundAuditRole ? "" : e;
    },
    // tabs切换
    handleClick(e, type) {
      console.log(e, type);
      if (type == "rebateActiveName") {
        this.rebateActiveName = e;
      } else if (type == "angPowActiveName") {
        this.angPowActiveName = e;
      } else if (type == "DepreciateName") {
        this.DepreciateName = e;
      }else{
        this.tableKey= Date.now();
        this.managerActiveName= e;
      }
    },
    addTemplate(type) {
      this.addTemplateType = type;
      switch (type) {
        case "red":
          this.addTemplateTitle = "添加个性配置（红包）";
          break;
        case "Depre":
          this.addTemplateTitle = "添加个性配置（利润提成）";
          break;
        case "machineTemplate":
          this.addTemplateTitle = "添加个性配置（按机型配置后返利）";
          break;
        default:
          this.addTemplateTitle = "添加个性配置（返利）";
      }
      // this.addTemplateTitle = type == 'red'?"添加个性配置（红包）":'添加个性配置（返利）'
      this.addTemplateShow = true;
    },
    addTemplateSure() {
      if (this.addTemplateType == "red") {
        let flag = false;
        this.angPowTemplateList.forEach((item) => {
          if (
            item.templateName == "公共配置（默认）" &&
            !item.regionList.length
          ) {
            flag = true;
          }
        });
        if (flag) {
          this.$message.error("请先设置红包公共配置参数");
          return;
        }
        if (!this.inputTemplateName) {
          this.$message.error("个性配置名称不能为空");
          return;
        }
        try {
          this.angPowTemplateList.forEach((item) => {
            if (this.inputTemplateName == item.templateName) {
              throw new Error("break");
            }
          });
        } catch (e) {
          this.$message.error("个性配置名称不能重复");
          return false;
        }
        this.angPowTemplateList.push({
          templateName: this.inputTemplateName,
          regionList: this.angPowTemplateList[0].regionList,
          storeList: [],
        });
        this.addTemplateShow = false;
      } else if (this.addTemplateType == "Depre") {
        let flag = false;
        this.cutPriceTemplateList.forEach((item) => {
          if (
            item.templateName == "公共配置（默认）" &&
            !item.cutPriceRegionList.length
          ) {
            flag = true;
          }
        });
        if (flag) {
          this.$message.error("请先设置常规压价提成配置参数");
          return;
        }
        if (!this.inputTemplateName) {
          this.$message.error("个性配置名称不能为空");
          return;
        }
        try {
          this.cutPriceTemplateList.forEach((item) => {
            if (this.inputTemplateName == item.templateName) {
              throw new Error("break");
            }
          });
        } catch (e) {
          this.$message.error("个性配置名称不能重复");
          return false;
        }
        this.cutPriceTemplateList.push({
          templateName: this.inputTemplateName,
          isOpenExtraDepreciateShare: this.cutPriceTemplateList[0]
            .isOpenExtraDepreciateShare,
          cutPriceRegionList: this.cutPriceTemplateList[0].cutPriceRegionList,
          extraCutPriceRegionList: this.cutPriceTemplateList[0]
            .extraCutPriceRegionList,
          storeList: [],
        });
        this.addTemplateShow = false;
      } else if (this.addTemplateType == "machineTemplate") {
        let flag = false;
        this.rebateTemplateList.forEach((item) => {
          if (
            item.templateName == "公共配置（默认）" &&
            !item.regionList.length
          ) {
            flag = true;
          }
        });
        if (flag) {
          this.$message.error("请先设置返利公共配置参数");
          return;
        }
        if (!this.inputTemplateName) {
          this.$message.error("个性配置名称不能为空");
          return;
        }
        try {
          this.machineTemplateList.forEach((item) => {
            if (this.inputTemplateName == item.templateName) {
              throw new Error("break");
            }
          });
        } catch (e) {
          this.$message.error("个性配置名称不能重复");
          return false;
        }
        this.machineTemplateList.push({
          templateName: this.inputTemplateName,
          regionList: JSON.parse(JSON.stringify(this.rebateRegionList)),
          machineIds: [],
        });
        this.rebateTemplateList.forEach((item) => {
          if (item.templateName === this.rebateActiveName) {
            item.machineTemplateList = this.machineTemplateList;
          }
        });
        this.addTemplateShow = false;
      } else {
        let flag = false;
        this.rebateTemplateList.forEach((item) => {
          if (
            item.templateName == "公共配置（默认）" &&
            !item.regionList.length
          ) {
            flag = true;
          }
        });
        if (flag) {
          this.$message.error("请先设置返利公共配置参数");
          return;
        }
        if (!this.inputTemplateName) {
          this.$message.error("个性配置名称不能为空");
          return;
        }
        try {
          this.rebateTemplateList.forEach((item) => {
            if (this.inputTemplateName == item.templateName) {
              throw new Error("break");
            }
          });
        } catch (e) {
          this.$message.error("个性配置名称不能重复");
          return false;
        }
        this.rebateTemplateList.push({
          templateName: this.inputTemplateName,
          regionList: this.rebateTemplateList[0].regionList,
          storeList: [],
          machineTemplateList: [],
        });
        this.addTemplateShow = false;
      }
    },
    machineTemplateListChange(index, data) {
      this.$set(this.machineTemplateList, index, {
        ...this.machineTemplateList[index],
        ...data,
      });
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName === this.rebateActiveName) {
          item.machineTemplateList = this.machineTemplateList;
        }
      });
    },
    machineTemplateDel(index) {
      this.machineTemplateList.splice(index, 1);
      this.rebateTemplateList.forEach((item) => {
        if (item.templateName === this.rebateActiveName) {
          item.machineTemplateList = this.machineTemplateList;
        }
      });
    },
    addTemplateClosed() {
      this.inputTemplateName = "";
      this.addTemplateShow = false;
    },
    storeHandleSelect(e, type) {
      this.selectStoreDelList = e;
      if (type == "red") {
        this.isRedStoreDel = e.length ? false : true;
      } else {
        this.isRebateStoreDel = e.length ? false : true;
      }
    },
    addStore(type, val) {
      this.importType = val;
      this.sureAddType = val;
      if (val == "01") {
        this.angPowTemplateList.forEach((item) => {
          if (item.storeList && item.storeList.length) {
            item.storeList.forEach((ele) => {
              this.storeDialogForm.assignedStoreIds.push(ele.id);
            });
          }
        });
      } else if (val == "03") {
        this.cutPriceTemplateList.forEach((item) => {
          if (item.storeList && item.storeList.length) {
            item.storeList.forEach((ele) => {
              this.storeDialogForm.assignedStoreIds.push(ele.id);
            });
          }
        });
      } else {
        this.rebateTemplateList.forEach((item) => {
          if (item.storeList && item.storeList.length) {
            item.storeList.forEach((ele) => {
              this.storeDialogForm.assignedStoreIds.push(ele.id);
            });
          }
        });
      }
      if (type == "select") {
        this.storeVisible = true;
        this.storeHandleCurrentChangeDialog(1);
      } else {
        this.importDialogVisible = true;
      }
    },
    storeHandleCurrentChangeDialog(val) {
      console.log(val);
      if (val) {
        this.storeDialogPage.pageNum = val;
      }
      let params = {
        companyId: this.companyId,
        pageNum: this.storeDialogPage.pageNum,
        pageSize: this.storeDialogPage.pageSize,
        ...this.storeDialogForm,
      };
      this.storeLoading = true;
      _api.getApplyStoreList(params).then((res) => {
        console.log(res);
        if (res.code === 1) {
          this.storeDialogDataList = res.data.records;
          this.storeDialogPage.pageNum = res.data.current;
          this.storeDialogPage.total = res.data.total;
        }
        this.storeLoading = false;
      });
    },
    storeDialogClose() {
      this.storeDialogForm.assignedStoreIds = [];
      this.storeVisible = false;
    },
    searchStore() {
      this.storeHandleCurrentChangeDialog(1);
    },
    // 标签下拉
    getStoreTagSelect() {
      _api.getStoreTagSelect({ companyId: this.companyId }).then((res) => {
        if (res.code == 1) {
          this.storeTagList = res.data;
        }
      });
    },
    // 区域下拉
    inspectorAreaSelect() {
      _api.inspectorAreaSelect({ companyId: this.companyId }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            if (item.areaId) {
              item.name = item.areaName + "-" + item.staffName;
            } else {
              item.name = item.staffName;
            }
          });
          this.inspectorAreaList = res.data;
        }
      });
    },
    addStoreHandleSelect(e) {
      console.log(e);
      this.selectAddStoreList = e;
    },
    // 确认添加门店
    addStoreSure() {
      if (!this.selectAddStoreList.length) {
        this.$message.error("请选择门店");
        return;
      }
      if (this.sureAddType == "01") {
        this.angPowStoreList = this.selectAddStoreList.concat(
          this.angPowStoreList
        );
        this.angPowTemplateList.forEach((item) => {
          if (item.templateName === this.angPowActiveName) {
            item.storeList = this.angPowStoreList;
          }
        });
      } else if (this.sureAddType == "03") {
        this.DepreciateStoreList = this.selectAddStoreList.concat(
          this.DepreciateStoreList
        );
        this.cutPriceTemplateList.forEach((item) => {
          if (item.templateName === this.DepreciateName) {
            item.storeList = this.DepreciateStoreList;
          }
        });
      } else {
        this.rebateStoreList = this.selectAddStoreList.concat(
          this.rebateStoreList
        );
        this.rebateTemplateList.forEach((item) => {
          if (item.templateName === this.rebateActiveName) {
            item.storeList = this.rebateStoreList;
          }
        });
      }

      this.storeVisible = false;
    },
    batchDel(type) {
      this.tableType = type;
      this.delDialogTitle = "删除确认";
      this.dialogDelVisible = true;
    },
    // 导入弹框关闭
    importDialogClosed() {
      this.importDialogVisible = false;
      this.$refs.upload.clearFiles();
    },
    // 导入弹框确定
    importSuccess() {
      this.$refs.upload.submit();
    },
    download() {
      const link = document.createElement("a");
      link.href = "/static/支付配置门店导入模板.xlsx";
      link.setAttribute("download", "支付配置门店导入模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    onUpload(e) {
      this.headers.TOKEN = encryptByDES(
        encryptByDES(
          new Date().getTime().toString(),
          "63e42c2444e94c1ebca21d30d2aa39a5"
        ),
        localStorage.getItem("token") || ""
      );
    },
    uploadFile(params) {
      console.log("uploadFile", params);
      const _file = params.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      formData.append("companyId", this.companyId);
      formData.append(
        "assignedStoreIds",
        this.storeDialogForm.assignedStoreIds
      );
      // 发起请求
      _api
        .analysisStoreExcel(formData)
        .then((res) => {
          if (res.code === 1) {
            console.log(res);
            if (this.importType == "01") {
              this.angPowStoreList = res.data.concat(this.angPowStoreList);
              this.angPowTemplateList.forEach((item) => {
                if (item.templateName === this.angPowActiveName) {
                  item.storeList = this.angPowStoreList;
                }
              });
            } else {
              this.rebateStoreList = res.data.concat(this.rebateStoreList);
              this.rebateTemplateList.forEach((item) => {
                if (item.templateName === this.rebateActiveName) {
                  item.storeList = this.rebateStoreList;
                }
              });
            }
            this.importDialogVisible = false;
          } else {
            this.$refs.upload.clearFiles();
            this.$message({
              type: "warning",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$refs.upload.clearFiles();
        });
    },
    // 分享奖励输入框失焦
    shareRewardBlur() {
      if (this.miniMallShareReward == 0 || this.miniMallShareReward == "") {
        this.$message.error("获得奖励不能为空且必须大于0");
        this.miniMallShareReward = 1;
      }
    },
    //限制一位小数
    numberCheck(prop) {
      var str = this.ruleForm[prop];
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换，保留数字和小数点
      str = str.match(/^\d*(\.?\d{0,1})/g)[0] || null;
      this.ruleForm[prop] = str;
    },
    numberCheckData(prop) {
      var str = this[prop];
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换，保留数字和小数点
      str = str.match(/^\d*(\.?\d{0,1})/g)[0] || null;
      this[prop] = str;
    },
    //转数字
    numberFn(prop) {
      if (!this.ruleForm[prop]) {
        return;
      }
      var str = this.ruleForm[prop];
      let num = Number(str);
      if (prop == "rebate" && num == 0) {
        this.ruleForm["rebateLimit"] = 0;
      }
      if (prop == "delayRebate" && num == 0) {
        this.ruleForm["delayRebateLimit"] = 0;
      }
      if (prop == "shopownerReward" && num == 0) {
        this.ruleForm["shopownerRewardLimit"] = 0;
      }
      if (prop == "clerkReward" && num == 0) {
        this.ruleForm["clerkRewardLimit"] = 0;
      }
      if (prop == "cutPriceScope" && num == 0) {
        this.ruleForm["cutPriceScopeLimit"] = 0;
      }
      this.ruleForm[prop] = num;
    },
    //限制一位小数
    RoyaltyNumberCheck(prop) {
      var str = this.RoyaltyRuleForm[prop];
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换，保留数字和小数点
      str = str.match(/^\d*(\.?\d{0,1})/g)[0] || null;
      this.RoyaltyRuleForm[prop] = str;
    },
    //限制一位小数
    profitNumberCheck(prop) {
      var str = this.profitRuleForm[prop];
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换，保留数字和小数点
      str = str.match(/^\d*(\.?\d{0,1})/g)[0] || null;
      this.profitRuleForm[prop] = str;
    },
    //限制一位小数
    profitNumberCheck1(prop) {
      var str = this.calculateOutRuleForm[prop];
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换，保留数字和小数点
      str = str.match(/^\d*(\.?\d{0,1})/g)[0] || null;
      this.calculateOutRuleForm[prop] = str;
    },
    //限制两位小数
    limitInput(value, name) {
      let str = (value && value.split("")) || [];
      let reg1 = /\d/;
      let reg2 = /\./;
      // 第一个字符不能为小数点
      if (str[0] == ".") {
        this[name] = "";
        return;
      }
      // 过滤掉除数字和小数点外的字符
      value = str.filter((e) => reg1.test(e) || reg2.test(e));
      // 匹配小数点后只能有两位小数
      let valJoin = value.join("");
      this[name] = valJoin.match(/^\d*(\.?\d{0,2})/g)[0] || "";
    },
    //转数字
    RoyaltyNumberFn(prop) {
      if (!this.RoyaltyRuleForm[prop]) {
        return;
      }
      var str = this.RoyaltyRuleForm[prop];
      let num = Number(str);
      if (prop == "inspectorReward" && num == 0) {
        this.RoyaltyRuleForm["inspectorRewardLimit"] = 0;
      }
      if (prop == "founderReward" && num == 0) {
        this.RoyaltyRuleForm["founderRewardLimit"] = 0;
      }
      this.RoyaltyRuleForm[prop] = num;
    },
    //转数字
    profitNumberFn(prop) {
      if (!this.profitRuleForm[prop]) {
        return;
      }
      var str = this.profitRuleForm[prop];
      let num = Number(str);
      if (prop == "shopownerCutPrice" && num == 0) {
        this.profitRuleForm["shopownerCutPriceLimit"] = 0;
      }
      if (prop == "clerkCutPrice" && num == 0) {
        this.profitRuleForm["clerkCutPriceLimit"] = 0;
      }
      this.profitRuleForm[prop] = num;
    },
    //转数字
    profitNumberFn1(prop) {
      if (!this.calculateOutRuleForm[prop]) {
        return;
      }
      var str = this.calculateOutRuleForm[prop];
      let num = Number(str);
      if (prop == "shopownerCutPrice" && num == 0) {
        this.calculateOutRuleForm["shopownerCutPriceLimit"] = 0;
      }
      if (prop == "clerkCutPrice" && num == 0) {
        this.calculateOutRuleForm["clerkCutPriceLimit"] = 0;
      }
      this.calculateOutRuleForm[prop] = num;
    },
    //支付模式改变
    payModeChange(val) {
      console.log(val, "val--------------");
      //九讯云且选择可付款的情况下,以旧换新选是,禁用否;店员付款是否需要审核选无需审核;需审核禁用
      if (val == "01" && this.jxyCompanyId) {
        this.isuserPayeeModeTrade = true;
        this.userPayeeModeTrade = "01";
        this.isStaffPayUserAuditdis = true;
        this.isStaffPayUserAudit = "02";
      }
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.newFash {
  .emp_content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 442px;
    img {
      width: 230px;
      height: 88px;
    }
    p {
      margin-top: 10px;
      font-weight: 400;
      font-size: 12px;
      color: #777777;
    }
  }
  .gree_on {
    margin-left: 10px;
    text-align: center;
    line-height: 25px;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    padding: 0 8px;
    height: 24px;
    background: #26be3d;
    border-radius: 12px;
  }
  .red_dwon {
    background: #ee4b4b;
  }
  .faultBtn {
    width: 208px;
    height: 34px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e4ecfd;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 16px 0;
    .active {
      text-align: center;
      width: 50%;
      height: 30px;
      font-size: 12px;
      color: #0981ff;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      background: #f2f8ff;
      border-radius: 4px;
    }

    .none {
      text-align: center;
      width: 50%;
      height: 30px;
      font-size: 12px;
      color: #333333;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 30px;
      border-radius: 4px;
    }
  }
  .secondlevel {
    margin-top: 20px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    .left_line {
      width: 2px;
      height: 14px;
      margin-right: 6px;
      background: #0981ff;
      border-radius: 2px;
    }
  }
  .tab_slide {
    height: 38px;
    display: flex;
    border-bottom: 1px solid #edeffd;
  }
  .public_cation {
    cursor: pointer;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    min-width: 140px;
    padding: 0 20px;
    height: 38px;
    background: #f8f9fa;
    border-radius: 10px 10px 0px 0px;
  }
  .select_cation {
    font-weight: bold;
    font-size: 14px;
    color: #0981ff;
    background: #e4f1ff;
  }
  .fanli_cont {
    padding: 20px 0 15px 0;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    p {
      position: relative;
      z-index: 2;
    }
    .di_blue {
      position: relative;
      top: -8px;
      width: 78px;
      height: 6px;
      background: linear-gradient(129deg, #0981ff 0%, #abd4ff 100%);
      opacity: 0.45;
    }
  }
  .gray_style {
    margin-top: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 60px;
    background: #f8f9fa;
    border-radius: 8px;
    p {
      margin-right: 100px;
    }
  }
  .blod33 {
    color: #333333;
    font-weight: bold;
  }
  .Companprofiset {
    margin-bottom: 20px;
    padding: 0 20px;
    box-sizing: border-box;
    // height: 700px;
    overflow: auto;
    background: #ffffff;
    border-radius: 16px;
  }
  .cp_toptitle {
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    display: flex;
    align-items: center;
    height: 58px;
    border-bottom: 1px solid #edeffd;
  }
  .nf_top_tilte {
    padding: 0 20px;
    box-sizing: border-box;
    position: fixed;
    top: 90px;
    right: 0;
    z-index: 100;
    width: calc(100vw - 210px);
    height: 42px;
    background: #ffffff;
  }
  .nf_second_tabl {
    z-index: 100;
    padding: 0 20px;
    box-sizing: border-box;
    position: fixed;
    top: 132px;
    right: 0;
    width: calc(100vw - 210px);
    height: 66px;
    background: #f5f6fa;
  }
  .nf_f_content {
    position: absolute;
    bottom: 0;
    width: calc(100vw - 250px);
    height: 44px;
    background: #FFFFFF;
    border-radius: 8px;
  }
  .nosleststy {
    cursor: pointer;
    text-align: center;
    line-height: 44px;
    width: 168px;
height: 44px;
background: #FFFFFF;
font-weight: 400;
font-size: 14px;
color: #666666;
border-radius: 8px;
    position: relative;
  }
  .blueLineUNder{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 70px;
height: 3px;
background: #0981FF;
  }
  .nf_ta_slect {
    width: 168px;
    height: 44px;
    font-weight: 600;
    font-size: 16px;
    color: #0981FF;
    // background-image: url("https://img.fanxinghuishou.cn/20250619/037124440.png");
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
  }
  .font12_77 {
    font-weight: 400;
    font-size: 12px;
    color: #777777;
  }
  .font14_335 {
    font-weight: bold;
    font-size: 14px;
    color: #333333;
  }
  .dis {
    display: flex;
  }

  .flex_dt {
    flex-direction: column;
  }

  .al_c {
    align-items: center;
  }

  .ju_c {
    justify-content: center;
  }

  .ju_s {
    justify-content: space-between;
  }

  .ju_a {
    justify-content: space-around;
  }

  .ju_e {
    justify-content: space-evenly;
  }
}

.GlobalTable {
  .button_top {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .explain {
    width: 100%;
    background: #f5f6fa;
    border-radius: 10px;
    padding: 15px 30px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #666666;

    .remarks-title {
      width: max-content;
      height: 18px;
      padding: 0 9px;
      color: #ffffff;
      background: #ffaf29;
      border-radius: 10px 9px 9px 0px;
    }

    .remarks-li {
      position: relative;
      padding: 0 10px;
      margin-top: 12px;
    }

    .remarks-li::before {
      content: "";
      display: block;
      width: 6px;
      height: 6px;
      background: #ffaf29;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 7px;
    }
  }

  /deep/.el-input-group__append {
    border: 1px solid #0981ff;
    background: #0981ff;
    color: #ffffff;
  }

  .rules-form {
    .rule-title {
      display: flex;
      align-items: center;
      color: #ff8080;
      margin-bottom: 20px;
    }

    .tip_ico {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }

    /deep/.el-input-group__append {
      border: 1px solid #0981ff;
      background: #0981ff;
      color: #ffffff;
    }
  }

  .del-title {
    color: #ff8080;
    font-size: 12px;

    .sure_tip {
      margin-top: 15px;
      font-size: 16px;
      color: #333333;
    }
  }

  .tipColor {
    color: #ff687b;
  }

  .title-item {
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    color: #333333;
    font-weight: 700;
  }

  .business-info {
    height: 50px;
    background: #f5f6fa;
    border-radius: 10px;
    margin-bottom: 21px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
    padding: 0 10px;
  }

  .business-info > span {
    margin-right: 50px;
  }

  .profit-type {
    margin-bottom: 21px;
  }

  .profit-type > div {
    margin-bottom: 16px;

    span {
      color: #ff687b;
      font-size: 12px;
    }
  }

  .set-title {
    font-weight: bold;
    color: #333333;
    font-size: 16px;
    height: 16px;
    padding-left: 10px;
    border-left: 3px solid #0981ff;
    margin-bottom: 10px;
  }

  .set-title-little {
    position: relative;
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .set-title-little::before {
    content: "";
    display: block;
    width: 64px;
    height: 6px;
    background: linear-gradient(
      to right,
      rgba(255, 175, 41, 0.61) 39%,
      rgba(255, 175, 41, 0) 100%
    );
    opacity: 0.65;
    border-radius: 3px;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .staff-dialog {
    /deep/.el-radio__label {
      display: none;
    }
  }

  /deep/.el-tabs__nav-wrap::after {
    display: none !important;
  }

  .command {
    display: flex;
    align-items: center;

    /deep/.el-input {
      width: 300px;
    }
  }

  .line {
    height: 1px;
    background: #edeffd;
    margin-bottom: 20px;
  }

  .tag-list {
    display: flex;
    flex-flow: wrap;
  }

  .tag-style {
    min-width: 88px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    line-height: 12px;
    height: 26px;
    font-size: 12px;
    color: #0981ff;
    background: #ffffff;
    border: 1px solid #0981ff;
    border-radius: 13px;
    margin: 10px 0;
    margin-right: 10px;
  }

  .add-store-form {
    .item {
      margin-right: 30px;
    }
  }

  .store-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 20px;
  }

  .step {
    .step-title {
      color: #0981ff;
      margin-bottom: 10px;
      padding-left: 6px;
      border-left: 3px solid;
      border-radius: 1.5px;
    }

    .step-content,
    .step2-content {
      margin-bottom: 26px;
    }

    .step2-content > div {
      display: flex;
    }

    .step2-content {
      .upload-demo {
        display: flex;
        justify-content: start;

        .el-upload-list {
          width: 200px;
        }
      }
    }
  }

  .tip {
    margin-bottom: 12px;

    .tip-title {
      color: #666666;
      margin-right: 12px;
    }

    .tip-content {
      color: #ff687b;
      font-size: 12px;
    }
  }
}

/deep/.demo-ruleForm .el-form-item__content .el-input-group {
  vertical-align: middle;
}

.after-style {
  height: 80px;
  line-height: 30px;
  background: #f5f6fa;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 25px;
  box-sizing: border-box;
}

.factor-rate {
  width: 100px;
  margin-left: 5px;
}

/deep/.factor-rate .el-input__inner {
  padding: 0 5px;
  text-align: center;
}

.polpleSetstyle {
  width: 100%;
}

.dis_center_space_between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex {
  display: flex;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.flex-jb {
  justify-content: space-between;
}

.flex-aa {
  align-items: flex-start;
}

.tip-color {
  color: #ff687b;
  font-size: 12px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.ml-20 {
  margin-left: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.normalShow {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  height: 60px;
  padding: 5px;
  font-size: 14px;
  background-color: rgb(249, 230, 224);
}
</style>
